(function ($, undefined) {
    
    var smapi = window.smapi = window.smapi || {},
        extend = $.extend,
        each = $.each,
        proxy = $.proxy,
        noop = $.noop,
        isFunction = $.isFunction,
        globalize = window.Globalize;
    
    extend(smapi, { academic: {} });
    
    function RepeatPolicyModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            MaxNumRepeats: 0,
            RepeatLimitStartDate: null,
            RepeatLimitStartPeriodID: null,
            ProcessRuleSetID: null,
            RepeatEffectCumAttemptedHours: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.MaxNumRepeats = ko.validatedObservable(settings.MaxNumRepeats);
        this.RepeatLimitStartDate = ko.validatedObservable(settings.RepeatLimitStartDate);
        this.RepeatLimitStartPeriodID = ko.validatedObservable(settings.RepeatLimitStartPeriodID);
        this.ProcessRuleSetID = ko.validatedObservable(settings.ProcessRuleSetID);
        this.RepeatEffectCumAttemptedHours = ko.validatedObservable(settings.RepeatEffectCumAttemptedHours);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RepeatLimitStartPeriod = ko.observable();
        this.ProcessRuleSet = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.MaxNumRepeats != undefined) {
                loaded.MaxNumRepeats(responseData.MaxNumRepeats);
            }
            if (responseData.RepeatLimitStartDate != undefined) {
                loaded.RepeatLimitStartDate(responseData.RepeatLimitStartDate);
            }
            if (responseData.RepeatLimitStartPeriodID != undefined) {
                loaded.RepeatLimitStartPeriodID(responseData.RepeatLimitStartPeriodID);
            }
            if (responseData.ProcessRuleSetID != undefined) {
                loaded.ProcessRuleSetID(responseData.ProcessRuleSetID);
            }
            if (responseData.RepeatEffectCumAttemptedHours != undefined) {
                loaded.RepeatEffectCumAttemptedHours(responseData.RepeatEffectCumAttemptedHours);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RepeatLimitStartPeriod != null) {
                loaded.RepeatLimitStartPeriod(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.RepeatLimitStartPeriod));
            }
            if (responseData.ProcessRuleSet != null) {
                loaded.ProcessRuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.ProcessRuleSet));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.RepeatPolicy', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MaxNumRepeats.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RepeatLimitStartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.RepeatLimitStartPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessRuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DivisionModel(options) {
        var defaults = {
            Code: '',
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Code = ko.validatedObservable(settings.Code);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Code != undefined) {
                loaded.Code(responseData.Code);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.Division', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Code.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicDeliveryMethodModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicDeliveryMethod', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicLevelModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Code: '',
            RepeatPolicyID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Code = ko.validatedObservable(settings.Code);
        this.RepeatPolicyID = ko.validatedObservable(settings.RepeatPolicyID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AvailableGoals = ko.observableArray([]);
        this.EnrollmentLevel = ko.observableArray([]);
        this.RepeatPolicy = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Code != undefined) {
                loaded.Code(responseData.Code);
            }
            if (responseData.RepeatPolicyID != undefined) {
                loaded.RepeatPolicyID(responseData.RepeatPolicyID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AvailableGoals != null && responseData.AvailableGoals.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AvailableGoals.length; i++) {
                    items.push(new smapi.academic.EducationalGoalModel().LoadFromResponse(responseData.AvailableGoals[i]));
                }
                loaded.AvailableGoals(items);
            }
            if (responseData.EnrollmentLevel != null && responseData.EnrollmentLevel.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EnrollmentLevel.length; i++) {
                    items.push(new smapi.academic.EnrollmentLevelModel().LoadFromResponse(responseData.EnrollmentLevel[i]));
                }
                loaded.EnrollmentLevel(items);
            }
            if (responseData.RepeatPolicy != null) {
                loaded.RepeatPolicy(new smapi.academic.RepeatPolicyModel().LoadFromResponse(responseData.RepeatPolicy));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicLevel', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Code.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.RepeatPolicyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function StudentModel(options) {
        var defaults = {
            PersonID: null,
            StudentID: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.StudentID = ko.validatedObservable(settings.StudentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.StudentID != undefined) {
                loaded.StudentID(responseData.StudentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.Student', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StudentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EnrollmentLevelModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            CreditHoursLowerThreshold: 0,
            CreditHoursUpperThreshold: 0,
            AcademicLevelID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.CreditHoursLowerThreshold = ko.validatedObservable(settings.CreditHoursLowerThreshold);
        this.CreditHoursUpperThreshold = ko.validatedObservable(settings.CreditHoursUpperThreshold);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicLevel = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.CreditHoursLowerThreshold != undefined) {
                loaded.CreditHoursLowerThreshold(responseData.CreditHoursLowerThreshold);
            }
            if (responseData.CreditHoursUpperThreshold != undefined) {
                loaded.CreditHoursUpperThreshold(responseData.CreditHoursUpperThreshold);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.EnrollmentLevel', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CreditHoursLowerThreshold.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CreditHoursUpperThreshold.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EmployeeModel(options) {
        var defaults = {
            PersonID: null,
            GPID: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.GPID = ko.validatedObservable(settings.GPID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.GPID != undefined) {
                loaded.GPID(responseData.GPID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.Employee', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GPID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MatriculationStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            GoodStanding: false,
            SortOrder: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.GoodStanding = ko.validatedObservable(settings.GoodStanding);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.GoodStanding != undefined) {
                loaded.GoodStanding(responseData.GoodStanding);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.MatriculationStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AthleticEligibilityCenterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AthleticEligibilityCenter', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 40,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '40')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function FERPAAlertsModel(options) {
        var defaults = {
            PersonID: 0,
            FERPATypeID: null,
            Notes: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.FERPATypeID = ko.validatedObservable(settings.FERPATypeID);
        this.Notes = ko.validatedObservable(settings.Notes);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.FERPAType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.FERPATypeID != undefined) {
                loaded.FERPATypeID(responseData.FERPATypeID);
            }
            if (responseData.Notes != undefined) {
                loaded.Notes(responseData.Notes);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.FERPAType != null) {
                loaded.FERPAType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.FERPAType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.FERPAAlerts', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FERPATypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Notes.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 500,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '500')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EducationalGoalModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Degreed: false,
            AcademicLevelID: null,
            Abbreviation: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            PrimaryGoal: false,
            IsSingle: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Degreed = ko.validatedObservable(settings.Degreed);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.Abbreviation = ko.validatedObservable(settings.Abbreviation);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.PrimaryGoal = ko.validatedObservable(settings.PrimaryGoal);
        this.IsSingle = ko.validatedObservable(settings.IsSingle);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicLevel = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Degreed != undefined) {
                loaded.Degreed(responseData.Degreed);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.Abbreviation != undefined) {
                loaded.Abbreviation(responseData.Abbreviation);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.PrimaryGoal != undefined) {
                loaded.PrimaryGoal(responseData.PrimaryGoal);
            }
            if (responseData.IsSingle != undefined) {
                loaded.IsSingle(responseData.IsSingle);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.EducationalGoal', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Abbreviation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ExternalEducationalGoalModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            Degreed: false,
            AcademicLevelID: null,
            Abbreviation: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Degreed = ko.validatedObservable(settings.Degreed);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.Abbreviation = ko.validatedObservable(settings.Abbreviation);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicLevel = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Degreed != undefined) {
                loaded.Degreed(responseData.Degreed);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.Abbreviation != undefined) {
                loaded.Abbreviation(responseData.Abbreviation);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ExternalEducationalGoal', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Abbreviation.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.SortOrder.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CollegeCodeModel(options) {
        var defaults = {
            Code: '',
            CollegeCodeTypeID: null,
            CollegeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Code = ko.validatedObservable(settings.Code);
        this.CollegeCodeTypeID = ko.validatedObservable(settings.CollegeCodeTypeID);
        this.CollegeID = ko.validatedObservable(settings.CollegeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.College = ko.observable();
        this.CollegeCodeType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Code != undefined) {
                loaded.Code(responseData.Code);
            }
            if (responseData.CollegeCodeTypeID != undefined) {
                loaded.CollegeCodeTypeID(responseData.CollegeCodeTypeID);
            }
            if (responseData.CollegeID != undefined) {
                loaded.CollegeID(responseData.CollegeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.College != null) {
                loaded.College(new smapi.academic.CollegeModel().LoadFromResponse(responseData.College));
            }
            if (responseData.CollegeCodeType != null) {
                loaded.CollegeCodeType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.CollegeCodeType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CollegeCode', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Code.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 20,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '20')
            }
        });
        this.CollegeCodeTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CollegeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CollegeModel(options) {
        var defaults = {
            OrganizationID: 0,
            DisplayName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.DisplayName = ko.validatedObservable(settings.DisplayName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Organization = ko.observable();
        this.CollegeCodes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.DisplayName != undefined) {
                loaded.DisplayName(responseData.DisplayName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            if (responseData.CollegeCodes != null && responseData.CollegeCodes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CollegeCodes.length; i++) {
                    items.push(new smapi.academic.CollegeCodeModel().LoadFromResponse(responseData.CollegeCodes[i]));
                }
                loaded.CollegeCodes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.College', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DisplayName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 60,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '60')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPeriodOverlapModel(options) {
        var defaults = {
            AcademicPeriodOverlapRatio: 0,
            AcademicPeriodID: null,
            OverlapAcademicPeriodID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicPeriodOverlapRatio = ko.validatedObservable(settings.AcademicPeriodOverlapRatio);
        this.AcademicPeriodID = ko.validatedObservable(settings.AcademicPeriodID);
        this.OverlapAcademicPeriodID = ko.validatedObservable(settings.OverlapAcademicPeriodID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicPeriod = ko.observable();
        this.OverlapAcademicPeriod = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicPeriodOverlapRatio != undefined) {
                loaded.AcademicPeriodOverlapRatio(responseData.AcademicPeriodOverlapRatio);
            }
            if (responseData.AcademicPeriodID != undefined) {
                loaded.AcademicPeriodID(responseData.AcademicPeriodID);
            }
            if (responseData.OverlapAcademicPeriodID != undefined) {
                loaded.OverlapAcademicPeriodID(responseData.OverlapAcademicPeriodID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicPeriod != null) {
                loaded.AcademicPeriod(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.AcademicPeriod));
            }
            if (responseData.OverlapAcademicPeriod != null) {
                loaded.OverlapAcademicPeriod(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.OverlapAcademicPeriod));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPeriodOverlap', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicPeriodOverlapRatio.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OverlapAcademicPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPeriodTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPeriodType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPeriodModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            StartDate: null,
            EndDate: null,
            PeriodID: null,
            AllowRegistration: false,
            RegistrationBegin: null,
            RegistrationEnd: null,
            CalendarYear: '',
            SortOrder: '',
            PeriodDurationTypeID: null,
            FacilityPeriodID: null,
            BillingPeriodID: null,
            ParentAcademicPeriodID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.PeriodID = ko.validatedObservable(settings.PeriodID);
        this.AllowRegistration = ko.validatedObservable(settings.AllowRegistration);
        this.RegistrationBegin = ko.validatedObservable(settings.RegistrationBegin);
        this.RegistrationEnd = ko.validatedObservable(settings.RegistrationEnd);
        this.CalendarYear = ko.validatedObservable(settings.CalendarYear);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.PeriodDurationTypeID = ko.validatedObservable(settings.PeriodDurationTypeID);
        this.FacilityPeriodID = ko.validatedObservable(settings.FacilityPeriodID);
        this.BillingPeriodID = ko.validatedObservable(settings.BillingPeriodID);
        this.ParentAcademicPeriodID = ko.validatedObservable(settings.ParentAcademicPeriodID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Period = ko.observable();
        this.PeriodDurationType = ko.observable();
        this.FacilityPeriod = ko.observable();
        this.BillingPeriod = ko.observable();
        this.ParentAcademicPeriod = ko.observable();
        this.ChildAcademicPeriods = ko.observableArray([]);
        this.AcademicPeriodOverlaps = ko.observableArray([]);
        this.Categories = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.PeriodID != undefined) {
                loaded.PeriodID(responseData.PeriodID);
            }
            if (responseData.AllowRegistration != undefined) {
                loaded.AllowRegistration(responseData.AllowRegistration);
            }
            if (responseData.RegistrationBegin != undefined) {
                loaded.RegistrationBegin(responseData.RegistrationBegin);
            }
            if (responseData.RegistrationEnd != undefined) {
                loaded.RegistrationEnd(responseData.RegistrationEnd);
            }
            if (responseData.CalendarYear != undefined) {
                loaded.CalendarYear(responseData.CalendarYear);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.PeriodDurationTypeID != undefined) {
                loaded.PeriodDurationTypeID(responseData.PeriodDurationTypeID);
            }
            if (responseData.FacilityPeriodID != undefined) {
                loaded.FacilityPeriodID(responseData.FacilityPeriodID);
            }
            if (responseData.BillingPeriodID != undefined) {
                loaded.BillingPeriodID(responseData.BillingPeriodID);
            }
            if (responseData.ParentAcademicPeriodID != undefined) {
                loaded.ParentAcademicPeriodID(responseData.ParentAcademicPeriodID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Period != null) {
                loaded.Period(new smapi.community.PeriodModel().LoadFromResponse(responseData.Period));
            }
            if (responseData.PeriodDurationType != null) {
                loaded.PeriodDurationType(new smapi.academic.PeriodDurationTypeModel().LoadFromResponse(responseData.PeriodDurationType));
            }
            if (responseData.FacilityPeriod != null) {
                loaded.FacilityPeriod(new smapi.facility.FacilityPeriodModel().LoadFromResponse(responseData.FacilityPeriod));
            }
            if (responseData.BillingPeriod != null) {
                loaded.BillingPeriod(new smapi.financials.BillingPeriodModel().LoadFromResponse(responseData.BillingPeriod));
            }
            if (responseData.ParentAcademicPeriod != null) {
                loaded.ParentAcademicPeriod(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.ParentAcademicPeriod));
            }
            if (responseData.ChildAcademicPeriods != null && responseData.ChildAcademicPeriods.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ChildAcademicPeriods.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.ChildAcademicPeriods[i]));
                }
                loaded.ChildAcademicPeriods(items);
            }
            if (responseData.AcademicPeriodOverlaps != null && responseData.AcademicPeriodOverlaps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AcademicPeriodOverlaps.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodOverlapModel().LoadFromResponse(responseData.AcademicPeriodOverlaps[i]));
                }
                loaded.AcademicPeriodOverlaps(items);
            }
            if (responseData.Categories != null && responseData.Categories.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Categories.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodTypeModel().LoadFromResponse(responseData.Categories[i]));
                }
                loaded.Categories(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPeriod', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RegistrationBegin.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.RegistrationEnd.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CalendarYear.extend({
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 12,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '12')
            }
        });
        this.PeriodDurationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.FacilityPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BillingPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParentAcademicPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PeriodDurationTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.PeriodDurationTypeThresholds = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PeriodDurationTypeThresholds != null && responseData.PeriodDurationTypeThresholds.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PeriodDurationTypeThresholds.length; i++) {
                    items.push(new smapi.academic.PeriodDurationTypeThresholdModel().LoadFromResponse(responseData.PeriodDurationTypeThresholds[i]));
                }
                loaded.PeriodDurationTypeThresholds(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PeriodDurationType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PeriodDurationTypeThresholdModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AcademicLevelID: null,
            HourThreshold: 0,
            CourseThreshold: 0,
            ThresholdTypeID: null,
            EnrollmentLoadID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.HourThreshold = ko.validatedObservable(settings.HourThreshold);
        this.CourseThreshold = ko.validatedObservable(settings.CourseThreshold);
        this.ThresholdTypeID = ko.validatedObservable(settings.ThresholdTypeID);
        this.EnrollmentLoadID = ko.validatedObservable(settings.EnrollmentLoadID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicLevel = ko.observable();
        this.ThresholdType = ko.observable();
        this.EnrollmentLoad = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.HourThreshold != undefined) {
                loaded.HourThreshold(responseData.HourThreshold);
            }
            if (responseData.CourseThreshold != undefined) {
                loaded.CourseThreshold(responseData.CourseThreshold);
            }
            if (responseData.ThresholdTypeID != undefined) {
                loaded.ThresholdTypeID(responseData.ThresholdTypeID);
            }
            if (responseData.EnrollmentLoadID != undefined) {
                loaded.EnrollmentLoadID(responseData.EnrollmentLoadID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.ThresholdType != null) {
                loaded.ThresholdType(new smapi.academic.ThresholdTypeModel().LoadFromResponse(responseData.ThresholdType));
            }
            if (responseData.EnrollmentLoad != null) {
                loaded.EnrollmentLoad(new smapi.academic.EnrollmentLoadModel().LoadFromResponse(responseData.EnrollmentLoad));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PeriodDurationTypeThreshold', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HourThreshold.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseThreshold.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ThresholdTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnrollmentLoadID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ThresholdTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ThresholdType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ProgramMasterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            DivisionID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.DivisionID = ko.validatedObservable(settings.DivisionID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Division = ko.observable();
        this.AvailableConcentrations = ko.observableArray([]);
        this.Goals = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.DivisionID != undefined) {
                loaded.DivisionID(responseData.DivisionID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Division != null) {
                loaded.Division(new smapi.academic.DivisionModel().LoadFromResponse(responseData.Division));
            }
            if (responseData.AvailableConcentrations != null && responseData.AvailableConcentrations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AvailableConcentrations.length; i++) {
                    items.push(new smapi.academic.ConcentrationMasterModel().LoadFromResponse(responseData.AvailableConcentrations[i]));
                }
                loaded.AvailableConcentrations(items);
            }
            if (responseData.Goals != null && responseData.Goals.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Goals.length; i++) {
                    items.push(new smapi.academic.EducationalGoalModel().LoadFromResponse(responseData.Goals[i]));
                }
                loaded.Goals(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ProgramMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.DivisionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ConcentrationTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ConcentrationType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function HonorModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.Honor', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ConcentrationMasterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ProgramID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Program = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Program != null) {
                loaded.Program(new smapi.academic.ProgramMasterModel().LoadFromResponse(responseData.Program));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ConcentrationMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonAcademicGoalConcentrationModel(options) {
        var defaults = {
            PersonAcademicGoalID: null,
            ConcentrationTypeID: null,
            ConcentrationID: null,
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonAcademicGoalID = ko.validatedObservable(settings.PersonAcademicGoalID);
        this.ConcentrationTypeID = ko.validatedObservable(settings.ConcentrationTypeID);
        this.ConcentrationID = ko.validatedObservable(settings.ConcentrationID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ConcentrationType = ko.observable();
        this.ConcentrationMaster = ko.observable();
        this.PersonAcademicGoal = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonAcademicGoalID != undefined) {
                loaded.PersonAcademicGoalID(responseData.PersonAcademicGoalID);
            }
            if (responseData.ConcentrationTypeID != undefined) {
                loaded.ConcentrationTypeID(responseData.ConcentrationTypeID);
            }
            if (responseData.ConcentrationID != undefined) {
                loaded.ConcentrationID(responseData.ConcentrationID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ConcentrationType != null) {
                loaded.ConcentrationType(new smapi.academic.ConcentrationTypeModel().LoadFromResponse(responseData.ConcentrationType));
            }
            if (responseData.ConcentrationMaster != null) {
                loaded.ConcentrationMaster(new smapi.academic.ConcentrationMasterModel().LoadFromResponse(responseData.ConcentrationMaster));
            }
            if (responseData.PersonAcademicGoal != null) {
                loaded.PersonAcademicGoal(new smapi.academic.PersonAcademicGoalModel().LoadFromResponse(responseData.PersonAcademicGoal));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PersonAcademicGoalConcentration', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonAcademicGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ConcentrationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ConcentrationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonAcademicGoalHonorModel(options) {
        var defaults = {
            PersonAcademicGoalID: null,
            HonorID: 0,
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonAcademicGoalID = ko.validatedObservable(settings.PersonAcademicGoalID);
        this.HonorID = ko.validatedObservable(settings.HonorID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Honor = ko.observable();
        this.PersonAcademicGoal = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonAcademicGoalID != undefined) {
                loaded.PersonAcademicGoalID(responseData.PersonAcademicGoalID);
            }
            if (responseData.HonorID != undefined) {
                loaded.HonorID(responseData.HonorID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Honor != null) {
                loaded.Honor(new smapi.academic.HonorModel().LoadFromResponse(responseData.Honor));
            }
            if (responseData.PersonAcademicGoal != null) {
                loaded.PersonAcademicGoal(new smapi.academic.PersonAcademicGoalModel().LoadFromResponse(responseData.PersonAcademicGoal));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PersonAcademicGoalHonor', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonAcademicGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.HonorID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonAcademicGoalModel(options) {
        var defaults = {
            PersonID: 0,
            GoalEarned: false,
            ConfirmDate: null,
            GraduationDate: null,
            EducationalGoalID: 0,
            TransferGoal: false,
            AdmissionDate: null,
            CollegeID: null,
            OtherEducationalGoal: '',
            EducationRanking: '',
            GPA: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.GoalEarned = ko.validatedObservable(settings.GoalEarned);
        this.ConfirmDate = ko.validatedObservable(settings.ConfirmDate);
        this.GraduationDate = ko.validatedObservable(settings.GraduationDate);
        this.EducationalGoalID = ko.validatedObservable(settings.EducationalGoalID);
        this.TransferGoal = ko.validatedObservable(settings.TransferGoal);
        this.AdmissionDate = ko.validatedObservable(settings.AdmissionDate);
        this.CollegeID = ko.validatedObservable(settings.CollegeID);
        this.OtherEducationalGoal = ko.validatedObservable(settings.OtherEducationalGoal);
        this.EducationRanking = ko.validatedObservable(settings.EducationRanking);
        this.GPA = ko.validatedObservable(settings.GPA);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.ExternalEducationalGoal = ko.observable();
        this.College = ko.observable();
        this.PersonAcademicGoalHonors = ko.observableArray([]);
        this.PersonGoalPrograms = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.GoalEarned != undefined) {
                loaded.GoalEarned(responseData.GoalEarned);
            }
            if (responseData.ConfirmDate != undefined) {
                loaded.ConfirmDate(responseData.ConfirmDate);
            }
            if (responseData.GraduationDate != undefined) {
                loaded.GraduationDate(responseData.GraduationDate);
            }
            if (responseData.EducationalGoalID != undefined) {
                loaded.EducationalGoalID(responseData.EducationalGoalID);
            }
            if (responseData.TransferGoal != undefined) {
                loaded.TransferGoal(responseData.TransferGoal);
            }
            if (responseData.AdmissionDate != undefined) {
                loaded.AdmissionDate(responseData.AdmissionDate);
            }
            if (responseData.CollegeID != undefined) {
                loaded.CollegeID(responseData.CollegeID);
            }
            if (responseData.OtherEducationalGoal != undefined) {
                loaded.OtherEducationalGoal(responseData.OtherEducationalGoal);
            }
            if (responseData.EducationRanking != undefined) {
                loaded.EducationRanking(responseData.EducationRanking);
            }
            if (responseData.GPA != undefined) {
                loaded.GPA(responseData.GPA);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.ExternalEducationalGoal != null) {
                loaded.ExternalEducationalGoal(new smapi.academic.ExternalEducationalGoalModel().LoadFromResponse(responseData.ExternalEducationalGoal));
            }
            if (responseData.College != null) {
                loaded.College(new smapi.academic.CollegeModel().LoadFromResponse(responseData.College));
            }
            if (responseData.PersonAcademicGoalHonors != null && responseData.PersonAcademicGoalHonors.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PersonAcademicGoalHonors.length; i++) {
                    items.push(new smapi.academic.PersonAcademicGoalHonorModel().LoadFromResponse(responseData.PersonAcademicGoalHonors[i]));
                }
                loaded.PersonAcademicGoalHonors(items);
            }
            if (responseData.PersonGoalPrograms != null && responseData.PersonGoalPrograms.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.PersonGoalPrograms.length; i++) {
                    items.push(new smapi.academic.PersonGoalProgramModel().LoadFromResponse(responseData.PersonGoalPrograms[i]));
                }
                loaded.PersonGoalPrograms(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PersonAcademicGoal', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ConfirmDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.GraduationDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EducationalGoalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AdmissionDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CollegeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OtherEducationalGoal.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.EducationRanking.extend({
            maxLength: {
                params: 1,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1')
            }
        });
        this.GPA.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseNeedMasterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            PerClass: false,
            PerGroup: false,
            PerStudent: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.PerClass = ko.validatedObservable(settings.PerClass);
        this.PerGroup = ko.validatedObservable(settings.PerGroup);
        this.PerStudent = ko.validatedObservable(settings.PerStudent);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.PerClass != undefined) {
                loaded.PerClass(responseData.PerClass);
            }
            if (responseData.PerGroup != undefined) {
                loaded.PerGroup(responseData.PerGroup);
            }
            if (responseData.PerStudent != undefined) {
                loaded.PerStudent(responseData.PerStudent);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseNeedMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseNeedModel(options) {
        var defaults = {
            CourseNeedMasterID: null,
            PerClass: false,
            PerGroup: false,
            PerStudent: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseNeedMasterID = ko.validatedObservable(settings.CourseNeedMasterID);
        this.PerClass = ko.validatedObservable(settings.PerClass);
        this.PerGroup = ko.validatedObservable(settings.PerGroup);
        this.PerStudent = ko.validatedObservable(settings.PerStudent);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseNeedMaster = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseNeedMasterID != undefined) {
                loaded.CourseNeedMasterID(responseData.CourseNeedMasterID);
            }
            if (responseData.PerClass != undefined) {
                loaded.PerClass(responseData.PerClass);
            }
            if (responseData.PerGroup != undefined) {
                loaded.PerGroup(responseData.PerGroup);
            }
            if (responseData.PerStudent != undefined) {
                loaded.PerStudent(responseData.PerStudent);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseNeedMaster != null) {
                loaded.CourseNeedMaster(new smapi.academic.CourseNeedMasterModel().LoadFromResponse(responseData.CourseNeedMaster));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseNeed', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseNeedMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LocationPropertyModel(options) {
        var defaults = {
            Quantity: 0,
            BeginDate: null,
            EndDate: null,
            PropertyID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Quantity = ko.validatedObservable(settings.Quantity);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.PropertyID = ko.validatedObservable(settings.PropertyID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.PropertyofLocation = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Quantity != undefined) {
                loaded.Quantity(responseData.Quantity);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.PropertyID != undefined) {
                loaded.PropertyID(responseData.PropertyID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PropertyofLocation != null) {
                loaded.PropertyofLocation(new smapi.academic.CourseNeedMasterModel().LoadFromResponse(responseData.PropertyofLocation));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.LocationProperty', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Quantity.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.PropertyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeCatalogModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            Remedial: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.Remedial = ko.validatedObservable(settings.Remedial);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AvailableGrades = ko.observableArray([]);
        this.CatalogCategories = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.Remedial != undefined) {
                loaded.Remedial(responseData.Remedial);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AvailableGrades != null && responseData.AvailableGrades.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AvailableGrades.length; i++) {
                    items.push(new smapi.academic.GradeMasterModel().LoadFromResponse(responseData.AvailableGrades[i]));
                }
                loaded.AvailableGrades(items);
            }
            if (responseData.CatalogCategories != null && responseData.CatalogCategories.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CatalogCategories.length; i++) {
                    items.push(new smapi.academic.CatalogCategoryModel().LoadFromResponse(responseData.CatalogCategories[i]));
                }
                loaded.CatalogCategories(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeCatalog', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeEffectModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            EffectEnrollmentEarned: false,
            EffectEarned: false,
            EffectEnrollmentHours: false,
            EffectHours: false,
            EffectEnrollmentGPA: false,
            EffectGPA: false,
            EffectAttemptedHours: false,
            ActAsUnGraded: false,
            NonWeighted: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.EffectEnrollmentEarned = ko.validatedObservable(settings.EffectEnrollmentEarned);
        this.EffectEarned = ko.validatedObservable(settings.EffectEarned);
        this.EffectEnrollmentHours = ko.validatedObservable(settings.EffectEnrollmentHours);
        this.EffectHours = ko.validatedObservable(settings.EffectHours);
        this.EffectEnrollmentGPA = ko.validatedObservable(settings.EffectEnrollmentGPA);
        this.EffectGPA = ko.validatedObservable(settings.EffectGPA);
        this.EffectAttemptedHours = ko.validatedObservable(settings.EffectAttemptedHours);
        this.ActAsUnGraded = ko.validatedObservable(settings.ActAsUnGraded);
        this.NonWeighted = ko.validatedObservable(settings.NonWeighted);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.EffectEnrollmentEarned != undefined) {
                loaded.EffectEnrollmentEarned(responseData.EffectEnrollmentEarned);
            }
            if (responseData.EffectEarned != undefined) {
                loaded.EffectEarned(responseData.EffectEarned);
            }
            if (responseData.EffectEnrollmentHours != undefined) {
                loaded.EffectEnrollmentHours(responseData.EffectEnrollmentHours);
            }
            if (responseData.EffectHours != undefined) {
                loaded.EffectHours(responseData.EffectHours);
            }
            if (responseData.EffectEnrollmentGPA != undefined) {
                loaded.EffectEnrollmentGPA(responseData.EffectEnrollmentGPA);
            }
            if (responseData.EffectGPA != undefined) {
                loaded.EffectGPA(responseData.EffectGPA);
            }
            if (responseData.EffectAttemptedHours != undefined) {
                loaded.EffectAttemptedHours(responseData.EffectAttemptedHours);
            }
            if (responseData.ActAsUnGraded != undefined) {
                loaded.ActAsUnGraded(responseData.ActAsUnGraded);
            }
            if (responseData.NonWeighted != undefined) {
                loaded.NonWeighted(responseData.NonWeighted);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeEffect', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeEffectTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeEffectType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeMasterGradeEffectModel(options) {
        var defaults = {
            GradeMasterID: null,
            GradeEffectTypeID: null,
            GradeEffectID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.GradeMasterID = ko.validatedObservable(settings.GradeMasterID);
        this.GradeEffectTypeID = ko.validatedObservable(settings.GradeEffectTypeID);
        this.GradeEffectID = ko.validatedObservable(settings.GradeEffectID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GradeMaster = ko.observable();
        this.GradeEffectType = ko.observable();
        this.GradeEffect = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.GradeMasterID != undefined) {
                loaded.GradeMasterID(responseData.GradeMasterID);
            }
            if (responseData.GradeEffectTypeID != undefined) {
                loaded.GradeEffectTypeID(responseData.GradeEffectTypeID);
            }
            if (responseData.GradeEffectID != undefined) {
                loaded.GradeEffectID(responseData.GradeEffectID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GradeMaster != null) {
                loaded.GradeMaster(new smapi.academic.GradeMasterModel().LoadFromResponse(responseData.GradeMaster));
            }
            if (responseData.GradeEffectType != null) {
                loaded.GradeEffectType(new smapi.academic.GradeEffectTypeModel().LoadFromResponse(responseData.GradeEffectType));
            }
            if (responseData.GradeEffect != null) {
                loaded.GradeEffect(new smapi.academic.GradeEffectModel().LoadFromResponse(responseData.GradeEffect));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeMasterGradeEffect', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.GradeMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradeEffectTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradeEffectID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeMasterModel(options) {
        var defaults = {
            CatalogID: null,
            Grade: '',
            GradePoint: 0,
            CanMarkAsRepeat: false,
            ScoreLower: 0,
            ScoreUpper: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CatalogID = ko.validatedObservable(settings.CatalogID);
        this.Grade = ko.validatedObservable(settings.Grade);
        this.GradePoint = ko.validatedObservable(settings.GradePoint);
        this.CanMarkAsRepeat = ko.validatedObservable(settings.CanMarkAsRepeat);
        this.ScoreLower = ko.validatedObservable(settings.ScoreLower);
        this.ScoreUpper = ko.validatedObservable(settings.ScoreUpper);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GradeCatalog = ko.observable();
        this.GradeEffects = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CatalogID != undefined) {
                loaded.CatalogID(responseData.CatalogID);
            }
            if (responseData.Grade != undefined) {
                loaded.Grade(responseData.Grade);
            }
            if (responseData.GradePoint != undefined) {
                loaded.GradePoint(responseData.GradePoint);
            }
            if (responseData.CanMarkAsRepeat != undefined) {
                loaded.CanMarkAsRepeat(responseData.CanMarkAsRepeat);
            }
            if (responseData.ScoreLower != undefined) {
                loaded.ScoreLower(responseData.ScoreLower);
            }
            if (responseData.ScoreUpper != undefined) {
                loaded.ScoreUpper(responseData.ScoreUpper);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GradeCatalog != null) {
                loaded.GradeCatalog(new smapi.academic.GradeCatalogModel().LoadFromResponse(responseData.GradeCatalog));
            }
            if (responseData.GradeEffects != null && responseData.GradeEffects.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.GradeEffects.length; i++) {
                    items.push(new smapi.academic.GradeMasterGradeEffectModel().LoadFromResponse(responseData.GradeEffects[i]));
                }
                loaded.GradeEffects(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CatalogID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Grade.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 15,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '15')
            }
        });
        this.GradePoint.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ScoreLower.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ScoreUpper.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseCatalogModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BeginDate: null,
            EndDate: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseCatalog', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 200,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '200')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseEnrollmentModeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ForCredit: false,
            EffectsGPA: false,
            BusinessMeaningName: '',
            ShortName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ForCredit = ko.validatedObservable(settings.ForCredit);
        this.EffectsGPA = ko.validatedObservable(settings.EffectsGPA);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ShortName = ko.validatedObservable(settings.ShortName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ApplicableRateTypes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ForCredit != undefined) {
                loaded.ForCredit(responseData.ForCredit);
            }
            if (responseData.EffectsGPA != undefined) {
                loaded.EffectsGPA(responseData.EffectsGPA);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ShortName != undefined) {
                loaded.ShortName(responseData.ShortName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ApplicableRateTypes != null && responseData.ApplicableRateTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ApplicableRateTypes.length; i++) {
                    items.push(new smapi.financials.RateTypeModel().LoadFromResponse(responseData.ApplicableRateTypes[i]));
                }
                loaded.ApplicableRateTypes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseEnrollmentMode', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ShortName.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EnrollmentModeMinGradeModel(options) {
        var defaults = {
            Name: '',
            MinimumPassingScore: 0,
            EnrollmentModeID: null,
            AcademicLevelID: 0,
            GradeCatalogExclusiveID: null,
            MinimumGradeID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.MinimumPassingScore = ko.validatedObservable(settings.MinimumPassingScore);
        this.EnrollmentModeID = ko.validatedObservable(settings.EnrollmentModeID);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.GradeCatalogExclusiveID = ko.validatedObservable(settings.GradeCatalogExclusiveID);
        this.MinimumGradeID = ko.validatedObservable(settings.MinimumGradeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.GradeCatalogExclusive = ko.observable();
        this.MinimumGrade = ko.observable();
        this.AcademicLevel = ko.observable();
        this.EnrollmentMode = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.MinimumPassingScore != undefined) {
                loaded.MinimumPassingScore(responseData.MinimumPassingScore);
            }
            if (responseData.EnrollmentModeID != undefined) {
                loaded.EnrollmentModeID(responseData.EnrollmentModeID);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.GradeCatalogExclusiveID != undefined) {
                loaded.GradeCatalogExclusiveID(responseData.GradeCatalogExclusiveID);
            }
            if (responseData.MinimumGradeID != undefined) {
                loaded.MinimumGradeID(responseData.MinimumGradeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.GradeCatalogExclusive != null) {
                loaded.GradeCatalogExclusive(new smapi.academic.GradeCatalogModel().LoadFromResponse(responseData.GradeCatalogExclusive));
            }
            if (responseData.MinimumGrade != null) {
                loaded.MinimumGrade(new smapi.academic.GradeMasterModel().LoadFromResponse(responseData.MinimumGrade));
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.EnrollmentMode != null) {
                loaded.EnrollmentMode(new smapi.academic.CourseEnrollmentModeModel().LoadFromResponse(responseData.EnrollmentMode));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.EnrollmentModeMinGrade', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.MinimumPassingScore.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnrollmentModeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicLevelID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradeCatalogExclusiveID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinimumGradeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseMasterMinGradeOverrideModel(options) {
        var defaults = {
            MinimumPassingScore: 0,
            GradeMasterID: null,
            EnrollmentModeMinGradeID: 0,
            CourseMasterID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.MinimumPassingScore = ko.validatedObservable(settings.MinimumPassingScore);
        this.GradeMasterID = ko.validatedObservable(settings.GradeMasterID);
        this.EnrollmentModeMinGradeID = ko.validatedObservable(settings.EnrollmentModeMinGradeID);
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MinimumGradeOverride = ko.observable();
        this.EnrollmentModeMinGrade = ko.observable();
        this.CourseMaster = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.MinimumPassingScore != undefined) {
                loaded.MinimumPassingScore(responseData.MinimumPassingScore);
            }
            if (responseData.GradeMasterID != undefined) {
                loaded.GradeMasterID(responseData.GradeMasterID);
            }
            if (responseData.EnrollmentModeMinGradeID != undefined) {
                loaded.EnrollmentModeMinGradeID(responseData.EnrollmentModeMinGradeID);
            }
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MinimumGradeOverride != null) {
                loaded.MinimumGradeOverride(new smapi.academic.GradeMasterModel().LoadFromResponse(responseData.MinimumGradeOverride));
            }
            if (responseData.EnrollmentModeMinGrade != null) {
                loaded.EnrollmentModeMinGrade(new smapi.academic.EnrollmentModeMinGradeModel().LoadFromResponse(responseData.EnrollmentModeMinGrade));
            }
            if (responseData.CourseMaster != null) {
                loaded.CourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseMaster));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseMasterMinGradeOverride', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.MinimumPassingScore.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradeMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnrollmentModeMinGradeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseMasterID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseMasterModel(options) {
        var defaults = {
            CourseID: '',
            DepartmentID: null,
            CourseNumber: '',
            CourseTypeID: null,
            Title: '',
            Description: '',
            CreditHours: 0,
            DefaultCreditHours: 0,
            ClockHours: 0,
            VariableCredit: false,
            CanRepeat: false,
            BeginDate: null,
            EndDate: null,
            AcademicLevelID: null,
            Catalog: false,
            ShowGradeReport: false,
            ShowTranscript: false,
            RequiresFacultyApproval: false,
            TranscriptTitle: '',
            TranscriptDescription: '',
            TranscriptCreditHours: 0,
            RepeatThreshold: 0,
            PassingScore: 0,
            SourceCollegeID: null,
            ExternalPassingGradeID: null,
            ExternalKey: '',
            CourseDepartment: '',
            IndependentStudy: false,
            MinimumAllowedCreditHours: 0,
            MaximumAllowedCreditHours: 0,
            AcademicDepartmentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseID = ko.validatedObservable(settings.CourseID);
        this.DepartmentID = ko.validatedObservable(settings.DepartmentID);
        this.CourseNumber = ko.validatedObservable(settings.CourseNumber);
        this.CourseTypeID = ko.validatedObservable(settings.CourseTypeID);
        this.Title = ko.validatedObservable(settings.Title);
        this.Description = ko.validatedObservable(settings.Description);
        this.CreditHours = ko.validatedObservable(settings.CreditHours);
        this.DefaultCreditHours = ko.validatedObservable(settings.DefaultCreditHours);
        this.ClockHours = ko.validatedObservable(settings.ClockHours);
        this.VariableCredit = ko.validatedObservable(settings.VariableCredit);
        this.CanRepeat = ko.validatedObservable(settings.CanRepeat);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.Catalog = ko.validatedObservable(settings.Catalog);
        this.ShowGradeReport = ko.validatedObservable(settings.ShowGradeReport);
        this.ShowTranscript = ko.validatedObservable(settings.ShowTranscript);
        this.RequiresFacultyApproval = ko.validatedObservable(settings.RequiresFacultyApproval);
        this.TranscriptTitle = ko.validatedObservable(settings.TranscriptTitle);
        this.TranscriptDescription = ko.validatedObservable(settings.TranscriptDescription);
        this.TranscriptCreditHours = ko.validatedObservable(settings.TranscriptCreditHours);
        this.RepeatThreshold = ko.validatedObservable(settings.RepeatThreshold);
        this.PassingScore = ko.validatedObservable(settings.PassingScore);
        this.SourceCollegeID = ko.validatedObservable(settings.SourceCollegeID);
        this.ExternalPassingGradeID = ko.validatedObservable(settings.ExternalPassingGradeID);
        this.ExternalKey = ko.validatedObservable(settings.ExternalKey);
        this.CourseDepartment = ko.validatedObservable(settings.CourseDepartment);
        this.IndependentStudy = ko.validatedObservable(settings.IndependentStudy);
        this.MinimumAllowedCreditHours = ko.validatedObservable(settings.MinimumAllowedCreditHours);
        this.MaximumAllowedCreditHours = ko.validatedObservable(settings.MaximumAllowedCreditHours);
        this.AcademicDepartmentID = ko.validatedObservable(settings.AcademicDepartmentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Department = ko.observable();
        this.CourseType = ko.observable();
        this.AcademicLevel = ko.observable();
        this.EnrollmentModeOverride = ko.observableArray([]);
        this.SourceCollege = ko.observable();
        this.ExternalPassingGrade = ko.observable();
        this.CourseGroups = ko.observableArray([]);
        this.Needs = ko.observableArray([]);
        this.CourseRequisites = ko.observableArray([]);
        this.CourseCatalog = ko.observableArray([]);
        this.CourseEquivalence = ko.observableArray([]);
        this.AcademicDepartment = ko.observable();
        this.SubjectAreas = ko.observableArray([]);
        this.DocumentRepository = ko.observableArray([]);
        this.Campuses = ko.observableArray([]);
        this.FundingSources = ko.observableArray([]);
        this.CourseUnits = ko.observableArray([]);
        this.LanguagesOfInstruction = ko.observableArray([]);
        this.QualificationModes = ko.observableArray([]);
        this.Requisites = ko.observableArray([]);
        this.NonCourseRequisites = ko.observableArray([]);
        this.LearningOutcomes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseID != undefined) {
                loaded.CourseID(responseData.CourseID);
            }
            if (responseData.DepartmentID != undefined) {
                loaded.DepartmentID(responseData.DepartmentID);
            }
            if (responseData.CourseNumber != undefined) {
                loaded.CourseNumber(responseData.CourseNumber);
            }
            if (responseData.CourseTypeID != undefined) {
                loaded.CourseTypeID(responseData.CourseTypeID);
            }
            if (responseData.Title != undefined) {
                loaded.Title(responseData.Title);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CreditHours != undefined) {
                loaded.CreditHours(responseData.CreditHours);
            }
            if (responseData.DefaultCreditHours != undefined) {
                loaded.DefaultCreditHours(responseData.DefaultCreditHours);
            }
            if (responseData.ClockHours != undefined) {
                loaded.ClockHours(responseData.ClockHours);
            }
            if (responseData.VariableCredit != undefined) {
                loaded.VariableCredit(responseData.VariableCredit);
            }
            if (responseData.CanRepeat != undefined) {
                loaded.CanRepeat(responseData.CanRepeat);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.Catalog != undefined) {
                loaded.Catalog(responseData.Catalog);
            }
            if (responseData.ShowGradeReport != undefined) {
                loaded.ShowGradeReport(responseData.ShowGradeReport);
            }
            if (responseData.ShowTranscript != undefined) {
                loaded.ShowTranscript(responseData.ShowTranscript);
            }
            if (responseData.RequiresFacultyApproval != undefined) {
                loaded.RequiresFacultyApproval(responseData.RequiresFacultyApproval);
            }
            if (responseData.TranscriptTitle != undefined) {
                loaded.TranscriptTitle(responseData.TranscriptTitle);
            }
            if (responseData.TranscriptDescription != undefined) {
                loaded.TranscriptDescription(responseData.TranscriptDescription);
            }
            if (responseData.TranscriptCreditHours != undefined) {
                loaded.TranscriptCreditHours(responseData.TranscriptCreditHours);
            }
            if (responseData.RepeatThreshold != undefined) {
                loaded.RepeatThreshold(responseData.RepeatThreshold);
            }
            if (responseData.PassingScore != undefined) {
                loaded.PassingScore(responseData.PassingScore);
            }
            if (responseData.SourceCollegeID != undefined) {
                loaded.SourceCollegeID(responseData.SourceCollegeID);
            }
            if (responseData.ExternalPassingGradeID != undefined) {
                loaded.ExternalPassingGradeID(responseData.ExternalPassingGradeID);
            }
            if (responseData.ExternalKey != undefined) {
                loaded.ExternalKey(responseData.ExternalKey);
            }
            if (responseData.CourseDepartment != undefined) {
                loaded.CourseDepartment(responseData.CourseDepartment);
            }
            if (responseData.IndependentStudy != undefined) {
                loaded.IndependentStudy(responseData.IndependentStudy);
            }
            if (responseData.MinimumAllowedCreditHours != undefined) {
                loaded.MinimumAllowedCreditHours(responseData.MinimumAllowedCreditHours);
            }
            if (responseData.MaximumAllowedCreditHours != undefined) {
                loaded.MaximumAllowedCreditHours(responseData.MaximumAllowedCreditHours);
            }
            if (responseData.AcademicDepartmentID != undefined) {
                loaded.AcademicDepartmentID(responseData.AcademicDepartmentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Department != null) {
                loaded.Department(new smapi.entities.GroupModel().LoadFromResponse(responseData.Department));
            }
            if (responseData.CourseType != null) {
                loaded.CourseType(new smapi.academic.CourseTypeModel().LoadFromResponse(responseData.CourseType));
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.EnrollmentModeOverride != null && responseData.EnrollmentModeOverride.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EnrollmentModeOverride.length; i++) {
                    items.push(new smapi.academic.CourseMasterMinGradeOverrideModel().LoadFromResponse(responseData.EnrollmentModeOverride[i]));
                }
                loaded.EnrollmentModeOverride(items);
            }
            if (responseData.SourceCollege != null) {
                loaded.SourceCollege(new smapi.academic.CollegeModel().LoadFromResponse(responseData.SourceCollege));
            }
            if (responseData.ExternalPassingGrade != null) {
                loaded.ExternalPassingGrade(new smapi.academic.GradeMasterModel().LoadFromResponse(responseData.ExternalPassingGrade));
            }
            if (responseData.CourseGroups != null && responseData.CourseGroups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseGroups.length; i++) {
                    items.push(new smapi.academic.CourseGroupModel().LoadFromResponse(responseData.CourseGroups[i]));
                }
                loaded.CourseGroups(items);
            }
            if (responseData.Needs != null && responseData.Needs.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Needs.length; i++) {
                    items.push(new smapi.academic.CourseNeedMasterModel().LoadFromResponse(responseData.Needs[i]));
                }
                loaded.Needs(items);
            }
            if (responseData.CourseRequisites != null && responseData.CourseRequisites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseRequisites.length; i++) {
                    items.push(new smapi.academic.CourseRequirementMasterModel().LoadFromResponse(responseData.CourseRequisites[i]));
                }
                loaded.CourseRequisites(items);
            }
            if (responseData.CourseCatalog != null && responseData.CourseCatalog.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseCatalog.length; i++) {
                    items.push(new smapi.academic.CourseCatalogModel().LoadFromResponse(responseData.CourseCatalog[i]));
                }
                loaded.CourseCatalog(items);
            }
            if (responseData.CourseEquivalence != null && responseData.CourseEquivalence.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseEquivalence.length; i++) {
                    items.push(new smapi.academic.CourseEquivalenceModel().LoadFromResponse(responseData.CourseEquivalence[i]));
                }
                loaded.CourseEquivalence(items);
            }
            if (responseData.AcademicDepartment != null) {
                loaded.AcademicDepartment(new smapi.academic.AcademicDepartmentModel().LoadFromResponse(responseData.AcademicDepartment));
            }
            if (responseData.SubjectAreas != null && responseData.SubjectAreas.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.SubjectAreas.length; i++) {
                    items.push(new smapi.academic.AcademicSubjectAreaModel().LoadFromResponse(responseData.SubjectAreas[i]));
                }
                loaded.SubjectAreas(items);
            }
            if (responseData.DocumentRepository != null && responseData.DocumentRepository.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.DocumentRepository.length; i++) {
                    items.push(new smapi.community.DocumentRepositoryModel().LoadFromResponse(responseData.DocumentRepository[i]));
                }
                loaded.DocumentRepository(items);
            }
            if (responseData.Campuses != null && responseData.Campuses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Campuses.length; i++) {
                    items.push(new smapi.facility.CampusModel().LoadFromResponse(responseData.Campuses[i]));
                }
                loaded.Campuses(items);
            }
            if (responseData.FundingSources != null && responseData.FundingSources.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.FundingSources.length; i++) {
                    items.push(new smapi.academic.CourseMasterFundingSourceModel().LoadFromResponse(responseData.FundingSources[i]));
                }
                loaded.FundingSources(items);
            }
            if (responseData.CourseUnits != null && responseData.CourseUnits.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseUnits.length; i++) {
                    items.push(new smapi.academic.CourseUnitMeasureModel().LoadFromResponse(responseData.CourseUnits[i]));
                }
                loaded.CourseUnits(items);
            }
            if (responseData.LanguagesOfInstruction != null && responseData.LanguagesOfInstruction.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.LanguagesOfInstruction.length; i++) {
                    items.push(new smapi.academic.LanguageOfInstructionModel().LoadFromResponse(responseData.LanguagesOfInstruction[i]));
                }
                loaded.LanguagesOfInstruction(items);
            }
            if (responseData.QualificationModes != null && responseData.QualificationModes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QualificationModes.length; i++) {
                    items.push(new smapi.academic.QualificationModeModel().LoadFromResponse(responseData.QualificationModes[i]));
                }
                loaded.QualificationModes(items);
            }
            if (responseData.Requisites != null && responseData.Requisites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Requisites.length; i++) {
                    items.push(new smapi.academic.CourseRequisiteModel().LoadFromResponse(responseData.Requisites[i]));
                }
                loaded.Requisites(items);
            }
            if (responseData.NonCourseRequisites != null && responseData.NonCourseRequisites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.NonCourseRequisites.length; i++) {
                    items.push(new smapi.academic.NonCourseRequisiteModel().LoadFromResponse(responseData.NonCourseRequisites[i]));
                }
                loaded.NonCourseRequisites(items);
            }
            if (responseData.LearningOutcomes != null && responseData.LearningOutcomes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.LearningOutcomes.length; i++) {
                    items.push(new smapi.academic.LearningOutcomeModel().LoadFromResponse(responseData.LearningOutcomes[i]));
                }
                loaded.LearningOutcomes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.DepartmentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseNumber.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.CourseTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Title.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.CreditHours.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultCreditHours.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ClockHours.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TranscriptTitle.extend({
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.TranscriptDescription.extend({
            maxLength: {
                params: 4000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '4000')
            }
        });
        this.TranscriptCreditHours.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RepeatThreshold.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PassingScore.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SourceCollegeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalPassingGradeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalKey.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.CourseDepartment.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.MinimumAllowedCreditHours.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaximumAllowedCreditHours.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicDepartmentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GoalStandingMasterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            GoodStanding: false,
            SortOrder: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.GoodStanding = ko.validatedObservable(settings.GoodStanding);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.GoodStanding != undefined) {
                loaded.GoodStanding(responseData.GoodStanding);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GoalStandingMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EnrollmentStatusMasterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CanRegister: false,
            SortOrder: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CanRegister = ko.validatedObservable(settings.CanRegister);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CanRegister != undefined) {
                loaded.CanRegister(responseData.CanRegister);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.EnrollmentStatusMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 10,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '10')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPeriodMilestoneGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Milestones = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Milestones != null && responseData.Milestones.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Milestones.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodMilestoneMasterModel().LoadFromResponse(responseData.Milestones[i]));
                }
                loaded.Milestones(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPeriodMilestoneGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPeriodMilestoneTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicPeriodMilestoneCriteria = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicPeriodMilestoneCriteria != null && responseData.AcademicPeriodMilestoneCriteria.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AcademicPeriodMilestoneCriteria.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodMilestoneCriteriaModel().LoadFromResponse(responseData.AcademicPeriodMilestoneCriteria[i]));
                }
                loaded.AcademicPeriodMilestoneCriteria(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPeriodMilestoneType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPeriodMilestoneCriteriaModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EnrollmentLevels = ko.observableArray([]);
        this.AcademicPrograms = ko.observableArray([]);
        this.Campuses = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EnrollmentLevels != null && responseData.EnrollmentLevels.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EnrollmentLevels.length; i++) {
                    items.push(new smapi.academic.EnrollmentLevelModel().LoadFromResponse(responseData.EnrollmentLevels[i]));
                }
                loaded.EnrollmentLevels(items);
            }
            if (responseData.AcademicPrograms != null && responseData.AcademicPrograms.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AcademicPrograms.length; i++) {
                    items.push(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.AcademicPrograms[i]));
                }
                loaded.AcademicPrograms(items);
            }
            if (responseData.Campuses != null && responseData.Campuses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Campuses.length; i++) {
                    items.push(new smapi.facility.CampusModel().LoadFromResponse(responseData.Campuses[i]));
                }
                loaded.Campuses(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPeriodMilestoneCriteria', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ProgramTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ProgramType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPeriodMilestoneMasterModel(options) {
        var defaults = {
            AcademicPeriodID: null,
            PeriodDurationTypeID: null,
            MilestoneBegin: null,
            MilestoneEnd: null,
            MilestoneBeginDaysFromPeriodStart: 0,
            MilestoneEndDaysFromPeriodStart: 0,
            MilestoneBeginDaysFromPeriodEnd: 0,
            MilestoneEndDaysFromPeriodEnd: 0,
            MilestoneID: null,
            MilestoneGroupID: 0,
            RelativeToCourse: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicPeriodID = ko.validatedObservable(settings.AcademicPeriodID);
        this.PeriodDurationTypeID = ko.validatedObservable(settings.PeriodDurationTypeID);
        this.MilestoneBegin = ko.validatedObservable(settings.MilestoneBegin);
        this.MilestoneEnd = ko.validatedObservable(settings.MilestoneEnd);
        this.MilestoneBeginDaysFromPeriodStart = ko.validatedObservable(settings.MilestoneBeginDaysFromPeriodStart);
        this.MilestoneEndDaysFromPeriodStart = ko.validatedObservable(settings.MilestoneEndDaysFromPeriodStart);
        this.MilestoneBeginDaysFromPeriodEnd = ko.validatedObservable(settings.MilestoneBeginDaysFromPeriodEnd);
        this.MilestoneEndDaysFromPeriodEnd = ko.validatedObservable(settings.MilestoneEndDaysFromPeriodEnd);
        this.MilestoneID = ko.validatedObservable(settings.MilestoneID);
        this.MilestoneGroupID = ko.validatedObservable(settings.MilestoneGroupID);
        this.RelativeToCourse = ko.validatedObservable(settings.RelativeToCourse);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicPeriod = ko.observable();
        this.Milestone = ko.observable();
        this.PeriodDurationType = ko.observable();
        this.MilestoneGroup = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicPeriodID != undefined) {
                loaded.AcademicPeriodID(responseData.AcademicPeriodID);
            }
            if (responseData.PeriodDurationTypeID != undefined) {
                loaded.PeriodDurationTypeID(responseData.PeriodDurationTypeID);
            }
            if (responseData.MilestoneBegin != undefined) {
                loaded.MilestoneBegin(responseData.MilestoneBegin);
            }
            if (responseData.MilestoneEnd != undefined) {
                loaded.MilestoneEnd(responseData.MilestoneEnd);
            }
            if (responseData.MilestoneBeginDaysFromPeriodStart != undefined) {
                loaded.MilestoneBeginDaysFromPeriodStart(responseData.MilestoneBeginDaysFromPeriodStart);
            }
            if (responseData.MilestoneEndDaysFromPeriodStart != undefined) {
                loaded.MilestoneEndDaysFromPeriodStart(responseData.MilestoneEndDaysFromPeriodStart);
            }
            if (responseData.MilestoneBeginDaysFromPeriodEnd != undefined) {
                loaded.MilestoneBeginDaysFromPeriodEnd(responseData.MilestoneBeginDaysFromPeriodEnd);
            }
            if (responseData.MilestoneEndDaysFromPeriodEnd != undefined) {
                loaded.MilestoneEndDaysFromPeriodEnd(responseData.MilestoneEndDaysFromPeriodEnd);
            }
            if (responseData.MilestoneID != undefined) {
                loaded.MilestoneID(responseData.MilestoneID);
            }
            if (responseData.MilestoneGroupID != undefined) {
                loaded.MilestoneGroupID(responseData.MilestoneGroupID);
            }
            if (responseData.RelativeToCourse != undefined) {
                loaded.RelativeToCourse(responseData.RelativeToCourse);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicPeriod != null) {
                loaded.AcademicPeriod(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.AcademicPeriod));
            }
            if (responseData.Milestone != null) {
                loaded.Milestone(new smapi.academic.AcademicPeriodMilestoneTypeModel().LoadFromResponse(responseData.Milestone));
            }
            if (responseData.PeriodDurationType != null) {
                loaded.PeriodDurationType(new smapi.academic.PeriodDurationTypeModel().LoadFromResponse(responseData.PeriodDurationType));
            }
            if (responseData.MilestoneGroup != null) {
                loaded.MilestoneGroup(new smapi.academic.AcademicPeriodMilestoneGroupModel().LoadFromResponse(responseData.MilestoneGroup));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPeriodMilestoneMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodDurationTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneBegin.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.MilestoneEnd.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.MilestoneBeginDaysFromPeriodStart.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneEndDaysFromPeriodStart.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneBeginDaysFromPeriodEnd.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneEndDaysFromPeriodEnd.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneGroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequirementModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            CourseMasterID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseMaster = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseMaster != null) {
                loaded.CourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseMaster));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequirement', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.CourseMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicRequirementModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            OrdinalType: null,
            MinOrdinal: 0,
            MaxOrdinal: 0,
            AllowAllCourses: false,
            CourseGroupID: null,
            MinGradePoint: 0,
            RequirementPriority: 0,
            ReqUsesCourse: false,
            IgnoreUsedCourseFlag: false,
            DynamicRequirement: false,
            BeginDate: null,
            EndDate: null,
            RequirementCategoryID: null,
            PeriodicityCount: 0,
            PeriodicityID: null,
            ReqsLogicalOperator: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.OrdinalType = ko.validatedObservable(settings.OrdinalType);
        this.MinOrdinal = ko.validatedObservable(settings.MinOrdinal);
        this.MaxOrdinal = ko.validatedObservable(settings.MaxOrdinal);
        this.AllowAllCourses = ko.validatedObservable(settings.AllowAllCourses);
        this.CourseGroupID = ko.validatedObservable(settings.CourseGroupID);
        this.MinGradePoint = ko.validatedObservable(settings.MinGradePoint);
        this.RequirementPriority = ko.validatedObservable(settings.RequirementPriority);
        this.ReqUsesCourse = ko.validatedObservable(settings.ReqUsesCourse);
        this.IgnoreUsedCourseFlag = ko.validatedObservable(settings.IgnoreUsedCourseFlag);
        this.DynamicRequirement = ko.validatedObservable(settings.DynamicRequirement);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.RequirementCategoryID = ko.validatedObservable(settings.RequirementCategoryID);
        this.PeriodicityCount = ko.validatedObservable(settings.PeriodicityCount);
        this.PeriodicityID = ko.validatedObservable(settings.PeriodicityID);
        this.ReqsLogicalOperator = ko.validatedObservable(settings.ReqsLogicalOperator);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseGroup = ko.observable();
        this.RequirementCategory = ko.observable();
        this.Periodicity = ko.observable();
        this.Requirements = ko.observableArray([]);
        this.EnrollmentLevel = ko.observableArray([]);
        this.AcademicProgram = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.OrdinalType != undefined) {
                loaded.OrdinalType(responseData.OrdinalType);
            }
            if (responseData.MinOrdinal != undefined) {
                loaded.MinOrdinal(responseData.MinOrdinal);
            }
            if (responseData.MaxOrdinal != undefined) {
                loaded.MaxOrdinal(responseData.MaxOrdinal);
            }
            if (responseData.AllowAllCourses != undefined) {
                loaded.AllowAllCourses(responseData.AllowAllCourses);
            }
            if (responseData.CourseGroupID != undefined) {
                loaded.CourseGroupID(responseData.CourseGroupID);
            }
            if (responseData.MinGradePoint != undefined) {
                loaded.MinGradePoint(responseData.MinGradePoint);
            }
            if (responseData.RequirementPriority != undefined) {
                loaded.RequirementPriority(responseData.RequirementPriority);
            }
            if (responseData.ReqUsesCourse != undefined) {
                loaded.ReqUsesCourse(responseData.ReqUsesCourse);
            }
            if (responseData.IgnoreUsedCourseFlag != undefined) {
                loaded.IgnoreUsedCourseFlag(responseData.IgnoreUsedCourseFlag);
            }
            if (responseData.DynamicRequirement != undefined) {
                loaded.DynamicRequirement(responseData.DynamicRequirement);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.RequirementCategoryID != undefined) {
                loaded.RequirementCategoryID(responseData.RequirementCategoryID);
            }
            if (responseData.PeriodicityCount != undefined) {
                loaded.PeriodicityCount(responseData.PeriodicityCount);
            }
            if (responseData.PeriodicityID != undefined) {
                loaded.PeriodicityID(responseData.PeriodicityID);
            }
            if (responseData.ReqsLogicalOperator != undefined) {
                loaded.ReqsLogicalOperator(responseData.ReqsLogicalOperator);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseGroup != null) {
                loaded.CourseGroup(new smapi.academic.CourseGroupModel().LoadFromResponse(responseData.CourseGroup));
            }
            if (responseData.RequirementCategory != null) {
                loaded.RequirementCategory(new smapi.academic.RequirementCategoryModel().LoadFromResponse(responseData.RequirementCategory));
            }
            if (responseData.Periodicity != null) {
                loaded.Periodicity(new smapi.community.PeriodicityModel().LoadFromResponse(responseData.Periodicity));
            }
            if (responseData.Requirements != null && responseData.Requirements.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Requirements.length; i++) {
                    items.push(new smapi.academic.AcademicRequirementModel().LoadFromResponse(responseData.Requirements[i]));
                }
                loaded.Requirements(items);
            }
            if (responseData.EnrollmentLevel != null && responseData.EnrollmentLevel.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EnrollmentLevel.length; i++) {
                    items.push(new smapi.academic.EnrollmentLevelModel().LoadFromResponse(responseData.EnrollmentLevel[i]));
                }
                loaded.EnrollmentLevel(items);
            }
            if (responseData.AcademicProgram != null && responseData.AcademicProgram.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AcademicProgram.length; i++) {
                    items.push(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.AcademicProgram[i]));
                }
                loaded.AcademicProgram(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicRequirement', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.OrdinalType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.MinOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxOrdinal.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinGradePoint.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequirementPriority.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.RequirementCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodicityCount.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodicityID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ReqsLogicalOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequirementMasterModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CoursePrerequisites = ko.observableArray([]);
        this.CourseCoRequisites = ko.observableArray([]);
        this.CourseAntiRequisites = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CoursePrerequisites != null && responseData.CoursePrerequisites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CoursePrerequisites.length; i++) {
                    items.push(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CoursePrerequisites[i]));
                }
                loaded.CoursePrerequisites(items);
            }
            if (responseData.CourseCoRequisites != null && responseData.CourseCoRequisites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseCoRequisites.length; i++) {
                    items.push(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseCoRequisites[i]));
                }
                loaded.CourseCoRequisites(items);
            }
            if (responseData.CourseAntiRequisites != null && responseData.CourseAntiRequisites.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseAntiRequisites.length; i++) {
                    items.push(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseAntiRequisites[i]));
                }
                loaded.CourseAntiRequisites(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequirementMaster', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseEquivalenceModel(options) {
        var defaults = {
            BeginDate: null,
            EndDate: null,
            CourseMasterID: 0,
            EqCourseMasterID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.EqCourseMasterID = ko.validatedObservable(settings.EqCourseMasterID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseMaster = ko.observable();
        this.EquivalentCourseMaster = ko.observable();
        this.Requirements = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.EqCourseMasterID != undefined) {
                loaded.EqCourseMasterID(responseData.EqCourseMasterID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseMaster != null) {
                loaded.CourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseMaster));
            }
            if (responseData.EquivalentCourseMaster != null) {
                loaded.EquivalentCourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.EquivalentCourseMaster));
            }
            if (responseData.Requirements != null && responseData.Requirements.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Requirements.length; i++) {
                    items.push(new smapi.academic.CourseRequirementModel().LoadFromResponse(responseData.Requirements[i]));
                }
                loaded.Requirements(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseEquivalence', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CourseMasterID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EqCourseMasterID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ProgramCategoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            AcademicProgramSuffix: '',
            SortOrder: 0,
            ProgramCategoryID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.AcademicProgramSuffix = ko.validatedObservable(settings.AcademicProgramSuffix);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ProgramCategoryID = ko.validatedObservable(settings.ProgramCategoryID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ProgramCategories = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.AcademicProgramSuffix != undefined) {
                loaded.AcademicProgramSuffix(responseData.AcademicProgramSuffix);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ProgramCategoryID != undefined) {
                loaded.ProgramCategoryID(responseData.ProgramCategoryID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ProgramCategories != null) {
                loaded.ProgramCategories(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.ProgramCategories));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ProgramCategory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.AcademicProgramSuffix.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ProgramConcentrationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ProgramID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Program = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Program != null) {
                loaded.Program(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.Program));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ProgramConcentration', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicManagerTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicManagerType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgramManagerModel(options) {
        var defaults = {
            AcademicManagerTypeID: 0,
            PersonID: null,
            ProgramID: null,
            EffectiveDateFrom: null,
            EffectiveDateTo: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicManagerTypeID = ko.validatedObservable(settings.AcademicManagerTypeID);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.EffectiveDateFrom = ko.validatedObservable(settings.EffectiveDateFrom);
        this.EffectiveDateTo = ko.validatedObservable(settings.EffectiveDateTo);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicManagerType = ko.observable();
        this.Person = ko.observable();
        this.Program = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicManagerTypeID != undefined) {
                loaded.AcademicManagerTypeID(responseData.AcademicManagerTypeID);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.EffectiveDateFrom != undefined) {
                loaded.EffectiveDateFrom(responseData.EffectiveDateFrom);
            }
            if (responseData.EffectiveDateTo != undefined) {
                loaded.EffectiveDateTo(responseData.EffectiveDateTo);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicManagerType != null) {
                loaded.AcademicManagerType(new smapi.academic.AcademicManagerTypeModel().LoadFromResponse(responseData.AcademicManagerType));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Program != null) {
                loaded.Program(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.Program));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgramManager', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicManagerTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EffectiveDateFrom.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveDateTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgramModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ApprovedDate: null,
            EffectiveDateFrom: null,
            EffectiveDateTo: null,
            ProgramMasterID: null,
            ProgramID: '',
            ProgramStatusID: null,
            DegreeAuditID: null,
            GoalID: 0,
            ProgramCategoryID: null,
            DeliveryMethodID: 0,
            DivisionID: null,
            TitleIVRefundTypeID: null,
            ProgramLength: 0,
            UnitLength: null,
            WeightFactor: 0,
            SortOrder: 0,
            AcademicRequirementID: null,
            BusinessMeaningName: '',
            AutoCreateAdmissionsProgram: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ApprovedDate = ko.validatedObservable(settings.ApprovedDate);
        this.EffectiveDateFrom = ko.validatedObservable(settings.EffectiveDateFrom);
        this.EffectiveDateTo = ko.validatedObservable(settings.EffectiveDateTo);
        this.ProgramMasterID = ko.validatedObservable(settings.ProgramMasterID);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.ProgramStatusID = ko.validatedObservable(settings.ProgramStatusID);
        this.DegreeAuditID = ko.validatedObservable(settings.DegreeAuditID);
        this.GoalID = ko.validatedObservable(settings.GoalID);
        this.ProgramCategoryID = ko.validatedObservable(settings.ProgramCategoryID);
        this.DeliveryMethodID = ko.validatedObservable(settings.DeliveryMethodID);
        this.DivisionID = ko.validatedObservable(settings.DivisionID);
        this.TitleIVRefundTypeID = ko.validatedObservable(settings.TitleIVRefundTypeID);
        this.ProgramLength = ko.validatedObservable(settings.ProgramLength);
        this.UnitLength = ko.validatedObservable(settings.UnitLength);
        this.WeightFactor = ko.validatedObservable(settings.WeightFactor);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.AcademicRequirementID = ko.validatedObservable(settings.AcademicRequirementID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.AutoCreateAdmissionsProgram = ko.validatedObservable(settings.AutoCreateAdmissionsProgram);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ProgramMaster = ko.observable();
        this.DeliveryMethod = ko.observable();
        this.Division = ko.observable();
        this.Concentrations = ko.observableArray([]);
        this.AcademicRequirement = ko.observable();
        this.DegreeAudit = ko.observable();
        this.Managers = ko.observableArray([]);
        this.ReportingCodes = ko.observableArray([]);
        this.Campuses = ko.observableArray([]);
        this.ProgramCategory = ko.observable();
        this.Goal = ko.observable();
        this.TitleIVRefundType = ko.observable();
        this.ProgramStatus = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ApprovedDate != undefined) {
                loaded.ApprovedDate(responseData.ApprovedDate);
            }
            if (responseData.EffectiveDateFrom != undefined) {
                loaded.EffectiveDateFrom(responseData.EffectiveDateFrom);
            }
            if (responseData.EffectiveDateTo != undefined) {
                loaded.EffectiveDateTo(responseData.EffectiveDateTo);
            }
            if (responseData.ProgramMasterID != undefined) {
                loaded.ProgramMasterID(responseData.ProgramMasterID);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.ProgramStatusID != undefined) {
                loaded.ProgramStatusID(responseData.ProgramStatusID);
            }
            if (responseData.DegreeAuditID != undefined) {
                loaded.DegreeAuditID(responseData.DegreeAuditID);
            }
            if (responseData.GoalID != undefined) {
                loaded.GoalID(responseData.GoalID);
            }
            if (responseData.ProgramCategoryID != undefined) {
                loaded.ProgramCategoryID(responseData.ProgramCategoryID);
            }
            if (responseData.DeliveryMethodID != undefined) {
                loaded.DeliveryMethodID(responseData.DeliveryMethodID);
            }
            if (responseData.DivisionID != undefined) {
                loaded.DivisionID(responseData.DivisionID);
            }
            if (responseData.TitleIVRefundTypeID != undefined) {
                loaded.TitleIVRefundTypeID(responseData.TitleIVRefundTypeID);
            }
            if (responseData.ProgramLength != undefined) {
                loaded.ProgramLength(responseData.ProgramLength);
            }
            if (responseData.UnitLength != undefined) {
                loaded.UnitLength(responseData.UnitLength);
            }
            if (responseData.WeightFactor != undefined) {
                loaded.WeightFactor(responseData.WeightFactor);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.AcademicRequirementID != undefined) {
                loaded.AcademicRequirementID(responseData.AcademicRequirementID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.AutoCreateAdmissionsProgram != undefined) {
                loaded.AutoCreateAdmissionsProgram(responseData.AutoCreateAdmissionsProgram);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ProgramMaster != null) {
                loaded.ProgramMaster(new smapi.academic.ProgramMasterModel().LoadFromResponse(responseData.ProgramMaster));
            }
            if (responseData.DeliveryMethod != null) {
                loaded.DeliveryMethod(new smapi.academic.AcademicDeliveryMethodModel().LoadFromResponse(responseData.DeliveryMethod));
            }
            if (responseData.Division != null) {
                loaded.Division(new smapi.academic.DivisionModel().LoadFromResponse(responseData.Division));
            }
            if (responseData.Concentrations != null && responseData.Concentrations.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Concentrations.length; i++) {
                    items.push(new smapi.academic.ProgramConcentrationModel().LoadFromResponse(responseData.Concentrations[i]));
                }
                loaded.Concentrations(items);
            }
            if (responseData.AcademicRequirement != null) {
                loaded.AcademicRequirement(new smapi.academic.AcademicRequirementModel().LoadFromResponse(responseData.AcademicRequirement));
            }
            if (responseData.DegreeAudit != null) {
                loaded.DegreeAudit(new smapi.academic.DegreeAuditModel().LoadFromResponse(responseData.DegreeAudit));
            }
            if (responseData.Managers != null && responseData.Managers.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Managers.length; i++) {
                    items.push(new smapi.academic.AcademicProgramManagerModel().LoadFromResponse(responseData.Managers[i]));
                }
                loaded.Managers(items);
            }
            if (responseData.ReportingCodes != null && responseData.ReportingCodes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReportingCodes.length; i++) {
                    items.push(new smapi.academic.AcademicReportingCodeModel().LoadFromResponse(responseData.ReportingCodes[i]));
                }
                loaded.ReportingCodes(items);
            }
            if (responseData.Campuses != null && responseData.Campuses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Campuses.length; i++) {
                    items.push(new smapi.facility.CampusModel().LoadFromResponse(responseData.Campuses[i]));
                }
                loaded.Campuses(items);
            }
            if (responseData.ProgramCategory != null) {
                loaded.ProgramCategory(new smapi.academic.ProgramCategoryModel().LoadFromResponse(responseData.ProgramCategory));
            }
            if (responseData.Goal != null) {
                loaded.Goal(new smapi.academic.EducationalGoalModel().LoadFromResponse(responseData.Goal));
            }
            if (responseData.TitleIVRefundType != null) {
                loaded.TitleIVRefundType(new smapi.entities.GlossaryModel().LoadFromResponse(responseData.TitleIVRefundType));
            }
            if (responseData.ProgramStatus != null) {
                loaded.ProgramStatus(new smapi.academic.ProgramStatusModel().LoadFromResponse(responseData.ProgramStatus));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgram', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ApprovedDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveDateFrom.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveDateTo.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ProgramMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramID.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ProgramStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DegreeAuditID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GoalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DeliveryMethodID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DivisionID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TitleIVRefundTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramLength.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.WeightFactor.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            }, 
            max: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '100')
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicRequirementID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 54,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '54')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ExternalAcademicProgramModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ProgramID: '',
            GoalID: 0,
            DeliveryMethodID: null,
            ProgramLength: 0,
            UnitLength: null,
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.GoalID = ko.validatedObservable(settings.GoalID);
        this.DeliveryMethodID = ko.validatedObservable(settings.DeliveryMethodID);
        this.ProgramLength = ko.validatedObservable(settings.ProgramLength);
        this.UnitLength = ko.validatedObservable(settings.UnitLength);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DeliveryMethod = ko.observable();
        this.ReportingCodes = ko.observableArray([]);
        this.Goal = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.GoalID != undefined) {
                loaded.GoalID(responseData.GoalID);
            }
            if (responseData.DeliveryMethodID != undefined) {
                loaded.DeliveryMethodID(responseData.DeliveryMethodID);
            }
            if (responseData.ProgramLength != undefined) {
                loaded.ProgramLength(responseData.ProgramLength);
            }
            if (responseData.UnitLength != undefined) {
                loaded.UnitLength(responseData.UnitLength);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DeliveryMethod != null) {
                loaded.DeliveryMethod(new smapi.academic.AcademicDeliveryMethodModel().LoadFromResponse(responseData.DeliveryMethod));
            }
            if (responseData.ReportingCodes != null && responseData.ReportingCodes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.ReportingCodes.length; i++) {
                    items.push(new smapi.academic.ExternalAcademicReportingCodeModel().LoadFromResponse(responseData.ReportingCodes[i]));
                }
                loaded.ReportingCodes(items);
            }
            if (responseData.Goal != null) {
                loaded.Goal(new smapi.academic.ExternalEducationalGoalModel().LoadFromResponse(responseData.Goal));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ExternalAcademicProgram', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.ProgramID.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.GoalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DeliveryMethodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramLength.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 54,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '54')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CatalogCategoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CatalogCategory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            TrackGradeHistory: false,
            BusinessMeaningName: '',
            AffectsGPA: false,
            RequiresRegistrarApproval: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.TrackGradeHistory = ko.validatedObservable(settings.TrackGradeHistory);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.AffectsGPA = ko.validatedObservable(settings.AffectsGPA);
        this.RequiresRegistrarApproval = ko.validatedObservable(settings.RequiresRegistrarApproval);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.TrackGradeHistory != undefined) {
                loaded.TrackGradeHistory(responseData.TrackGradeHistory);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.AffectsGPA != undefined) {
                loaded.AffectsGPA(responseData.AffectsGPA);
            }
            if (responseData.RequiresRegistrarApproval != undefined) {
                loaded.RequiresRegistrarApproval(responseData.RequiresRegistrarApproval);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeFormatModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeFormat', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequirementCategoryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ShowOnClient: false,
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ShowOnClient = ko.validatedObservable(settings.ShowOnClient);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ShowOnClient != undefined) {
                loaded.ShowOnClient(responseData.ShowOnClient);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.RequirementCategory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GradeProcessModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GradeProcess', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EnrollmentLoadModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            Fulltime: false,
            PELLImportKey: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.Fulltime = ko.validatedObservable(settings.Fulltime);
        this.PELLImportKey = ko.validatedObservable(settings.PELLImportKey);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.Fulltime != undefined) {
                loaded.Fulltime(responseData.Fulltime);
            }
            if (responseData.PELLImportKey != undefined) {
                loaded.PELLImportKey(responseData.PELLImportKey);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.EnrollmentLoad', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.PELLImportKey.extend({
            maxLength: {
                params: 30,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '30')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function GoalTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.GoalType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonGoalProgramModel(options) {
        var defaults = {
            PersonAcademicGoalID: null,
            ConcentrationID: null,
            GoalTypeID: 0,
            SortOrder: 0,
            ExternalAcademicProgramID: null,
            GPA: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.PersonAcademicGoalID = ko.validatedObservable(settings.PersonAcademicGoalID);
        this.ConcentrationID = ko.validatedObservable(settings.ConcentrationID);
        this.GoalTypeID = ko.validatedObservable(settings.GoalTypeID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ExternalAcademicProgramID = ko.validatedObservable(settings.ExternalAcademicProgramID);
        this.GPA = ko.validatedObservable(settings.GPA);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.PersonAcademicGoal = ko.observable();
        this.ConcentrationMaster = ko.observable();
        this.GoalType = ko.observable();
        this.ExternalAcademicProgram = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.PersonAcademicGoalID != undefined) {
                loaded.PersonAcademicGoalID(responseData.PersonAcademicGoalID);
            }
            if (responseData.ConcentrationID != undefined) {
                loaded.ConcentrationID(responseData.ConcentrationID);
            }
            if (responseData.GoalTypeID != undefined) {
                loaded.GoalTypeID(responseData.GoalTypeID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ExternalAcademicProgramID != undefined) {
                loaded.ExternalAcademicProgramID(responseData.ExternalAcademicProgramID);
            }
            if (responseData.GPA != undefined) {
                loaded.GPA(responseData.GPA);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.PersonAcademicGoal != null) {
                loaded.PersonAcademicGoal(new smapi.academic.PersonAcademicGoalModel().LoadFromResponse(responseData.PersonAcademicGoal));
            }
            if (responseData.ConcentrationMaster != null) {
                loaded.ConcentrationMaster(new smapi.academic.ConcentrationMasterModel().LoadFromResponse(responseData.ConcentrationMaster));
            }
            if (responseData.GoalType != null) {
                loaded.GoalType(new smapi.academic.GoalTypeModel().LoadFromResponse(responseData.GoalType));
            }
            if (responseData.ExternalAcademicProgram != null) {
                loaded.ExternalAcademicProgram(new smapi.academic.ExternalAcademicProgramModel().LoadFromResponse(responseData.ExternalAcademicProgram));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PersonGoalProgram', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.PersonAcademicGoalID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ConcentrationID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GoalTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalAcademicProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GPA.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ReasonModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.Reason', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PersonMetRequirementModel(options) {
        var defaults = {
            AcademicRequirementID: null,
            PersonID: null,
            RequirementMetDate: null,
            OverrideSystem: false,
            ReasonID: null,
            RequirementStatus: null,
            NoteID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicRequirementID = ko.validatedObservable(settings.AcademicRequirementID);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.RequirementMetDate = ko.validatedObservable(settings.RequirementMetDate);
        this.OverrideSystem = ko.validatedObservable(settings.OverrideSystem);
        this.ReasonID = ko.validatedObservable(settings.ReasonID);
        this.RequirementStatus = ko.validatedObservable(settings.RequirementStatus);
        this.NoteID = ko.validatedObservable(settings.NoteID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Person = ko.observable();
        this.Note = ko.observable();
        this.OverrideReason = ko.observable();
        this.AcademicRequirement = ko.observable();
        this.MetCourses = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicRequirementID != undefined) {
                loaded.AcademicRequirementID(responseData.AcademicRequirementID);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.RequirementMetDate != undefined) {
                loaded.RequirementMetDate(responseData.RequirementMetDate);
            }
            if (responseData.OverrideSystem != undefined) {
                loaded.OverrideSystem(responseData.OverrideSystem);
            }
            if (responseData.ReasonID != undefined) {
                loaded.ReasonID(responseData.ReasonID);
            }
            if (responseData.RequirementStatus != undefined) {
                loaded.RequirementStatus(responseData.RequirementStatus);
            }
            if (responseData.NoteID != undefined) {
                loaded.NoteID(responseData.NoteID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.Note != null) {
                loaded.Note(new smapi.community.ContactNoteModel().LoadFromResponse(responseData.Note));
            }
            if (responseData.OverrideReason != null) {
                loaded.OverrideReason(new smapi.academic.ReasonModel().LoadFromResponse(responseData.OverrideReason));
            }
            if (responseData.AcademicRequirement != null) {
                loaded.AcademicRequirement(new smapi.academic.AcademicRequirementModel().LoadFromResponse(responseData.AcademicRequirement));
            }
            if (responseData.MetCourses != null && responseData.MetCourses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.MetCourses.length; i++) {
                    items.push(new smapi.academic.MetRequirementCourseModel().LoadFromResponse(responseData.MetCourses[i]));
                }
                loaded.MetCourses(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PersonMetRequirement', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicRequirementID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequirementMetDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ReasonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RequirementStatus.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.NoteID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function MetRequirementCourseModel(options) {
        var defaults = {
            CourseID: 0,
            GradeID: null,
            CourseMasterID: 0,
            TransferCourseID: 0,
            TranscriptCourseID: 0,
            IsManualMap: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseID = ko.validatedObservable(settings.CourseID);
        this.GradeID = ko.validatedObservable(settings.GradeID);
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.TransferCourseID = ko.validatedObservable(settings.TransferCourseID);
        this.TranscriptCourseID = ko.validatedObservable(settings.TranscriptCourseID);
        this.IsManualMap = ko.validatedObservable(settings.IsManualMap);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Grade = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseID != undefined) {
                loaded.CourseID(responseData.CourseID);
            }
            if (responseData.GradeID != undefined) {
                loaded.GradeID(responseData.GradeID);
            }
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.TransferCourseID != undefined) {
                loaded.TransferCourseID(responseData.TransferCourseID);
            }
            if (responseData.TranscriptCourseID != undefined) {
                loaded.TranscriptCourseID(responseData.TranscriptCourseID);
            }
            if (responseData.IsManualMap != undefined) {
                loaded.IsManualMap(responseData.IsManualMap);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Grade != null) {
                loaded.Grade(new smapi.academic.GradeMasterModel().LoadFromResponse(responseData.Grade));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.MetRequirementCourse', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GradeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TransferCourseID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TranscriptCourseID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ProgramStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ProgramStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 250,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicDepartmentModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicDepartment', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicSubjectAreaModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicSubjectArea', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQualifierRuleTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQualifierRuleType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseUnitModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseUnit', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQueryFilterTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQueryFilterType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function PeriodOfCompletionUnitModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.PeriodOfCompletionUnit', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupCourseModel(options) {
        var defaults = {
            CourseMasterID: 0,
            UnitOfMeasureID: 0,
            Units: 0,
            MinGPA: 0,
            Required: false,
            AllowTransfer: false,
            AllowEquivalent: false,
            Summarize: false,
            DegreeCourseGroupID: 0,
            Fulfilled: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.UnitOfMeasureID = ko.validatedObservable(settings.UnitOfMeasureID);
        this.Units = ko.validatedObservable(settings.Units);
        this.MinGPA = ko.validatedObservable(settings.MinGPA);
        this.Required = ko.validatedObservable(settings.Required);
        this.AllowTransfer = ko.validatedObservable(settings.AllowTransfer);
        this.AllowEquivalent = ko.validatedObservable(settings.AllowEquivalent);
        this.Summarize = ko.validatedObservable(settings.Summarize);
        this.DegreeCourseGroupID = ko.validatedObservable(settings.DegreeCourseGroupID);
        this.Fulfilled = ko.validatedObservable(settings.Fulfilled);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Course = ko.observable();
        this.UnitOfMeasure = ko.observable();
        this.DegreeCourseGroup = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.UnitOfMeasureID != undefined) {
                loaded.UnitOfMeasureID(responseData.UnitOfMeasureID);
            }
            if (responseData.Units != undefined) {
                loaded.Units(responseData.Units);
            }
            if (responseData.MinGPA != undefined) {
                loaded.MinGPA(responseData.MinGPA);
            }
            if (responseData.Required != undefined) {
                loaded.Required(responseData.Required);
            }
            if (responseData.AllowTransfer != undefined) {
                loaded.AllowTransfer(responseData.AllowTransfer);
            }
            if (responseData.AllowEquivalent != undefined) {
                loaded.AllowEquivalent(responseData.AllowEquivalent);
            }
            if (responseData.Summarize != undefined) {
                loaded.Summarize(responseData.Summarize);
            }
            if (responseData.DegreeCourseGroupID != undefined) {
                loaded.DegreeCourseGroupID(responseData.DegreeCourseGroupID);
            }
            if (responseData.Fulfilled != undefined) {
                loaded.Fulfilled(responseData.Fulfilled);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Course != null) {
                loaded.Course(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.Course));
            }
            if (responseData.UnitOfMeasure != null) {
                loaded.UnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.UnitOfMeasure));
            }
            if (responseData.DegreeCourseGroup != null) {
                loaded.DegreeCourseGroup(new smapi.academic.DegreeCourseGroupModel().LoadFromResponse(responseData.DegreeCourseGroup));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupCourse', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseMasterID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UnitOfMeasureID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Units.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinGPA.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DegreeCourseGroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeCourseGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            DegreeRequirementID: 0,
            SortPriorityOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.DegreeRequirementID = ko.validatedObservable(settings.DegreeRequirementID);
        this.SortPriorityOrder = ko.validatedObservable(settings.SortPriorityOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeRequirement = ko.observable();
        this.Courses = ko.observableArray([]);
        this.Queries = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.DegreeRequirementID != undefined) {
                loaded.DegreeRequirementID(responseData.DegreeRequirementID);
            }
            if (responseData.SortPriorityOrder != undefined) {
                loaded.SortPriorityOrder(responseData.SortPriorityOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeRequirement != null) {
                loaded.DegreeRequirement(new smapi.academic.DegreeRequirementModel().LoadFromResponse(responseData.DegreeRequirement));
            }
            if (responseData.Courses != null && responseData.Courses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Courses.length; i++) {
                    items.push(new smapi.academic.CourseGroupCourseModel().LoadFromResponse(responseData.Courses[i]));
                }
                loaded.Courses(items);
            }
            if (responseData.Queries != null && responseData.Queries.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Queries.length; i++) {
                    items.push(new smapi.academic.CourseGroupQueryModel().LoadFromResponse(responseData.Queries[i]));
                }
                loaded.Queries(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeCourseGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DegreeRequirementID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortPriorityOrder.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQualifierRuleValueModel(options) {
        var defaults = {
            CourseGroupQualifierRuleID: 0,
            DisplayValue: '',
            Value: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseGroupQualifierRuleID = ko.validatedObservable(settings.CourseGroupQualifierRuleID);
        this.DisplayValue = ko.validatedObservable(settings.DisplayValue);
        this.Value = ko.validatedObservable(settings.Value);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseGroupQualifierRule = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseGroupQualifierRuleID != undefined) {
                loaded.CourseGroupQualifierRuleID(responseData.CourseGroupQualifierRuleID);
            }
            if (responseData.DisplayValue != undefined) {
                loaded.DisplayValue(responseData.DisplayValue);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseGroupQualifierRule != null) {
                loaded.CourseGroupQualifierRule(new smapi.academic.CourseGroupQualifierRuleModel().LoadFromResponse(responseData.CourseGroupQualifierRule));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQualifierRuleValue', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseGroupQualifierRuleID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DisplayValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQualifierRuleModel(options) {
        var defaults = {
            CourseGroupQualifierRuleTypeID: 0,
            CourseGroupQualifierBlockID: 0,
            UnitOfMeasureID: null,
            PeriodOfCompletionUnitID: null,
            AcademicDepartmentID: null,
            AcademicSubjectAreaID: null,
            DegreeCourseGroupID: null,
            IntValue1: 0,
            IntValue2: 0,
            DoubleValue1: 0,
            DoubleValue2: 0,
            SortOrder: 0,
            ComparisonOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseGroupQualifierRuleTypeID = ko.validatedObservable(settings.CourseGroupQualifierRuleTypeID);
        this.CourseGroupQualifierBlockID = ko.validatedObservable(settings.CourseGroupQualifierBlockID);
        this.UnitOfMeasureID = ko.validatedObservable(settings.UnitOfMeasureID);
        this.PeriodOfCompletionUnitID = ko.validatedObservable(settings.PeriodOfCompletionUnitID);
        this.AcademicDepartmentID = ko.validatedObservable(settings.AcademicDepartmentID);
        this.AcademicSubjectAreaID = ko.validatedObservable(settings.AcademicSubjectAreaID);
        this.DegreeCourseGroupID = ko.validatedObservable(settings.DegreeCourseGroupID);
        this.IntValue1 = ko.validatedObservable(settings.IntValue1);
        this.IntValue2 = ko.validatedObservable(settings.IntValue2);
        this.DoubleValue1 = ko.validatedObservable(settings.DoubleValue1);
        this.DoubleValue2 = ko.validatedObservable(settings.DoubleValue2);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ComparisonOperator = ko.validatedObservable(settings.ComparisonOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseGroupQualifierRuleType = ko.observable();
        this.CourseGroupQualifierBlock = ko.observable();
        this.UnitOfMeasure = ko.observable();
        this.PeriodOfCompletionUnit = ko.observable();
        this.AcademicDepartment = ko.observable();
        this.AcademicSubjectArea = ko.observable();
        this.DegreeCourseGroup = ko.observable();
        this.RuleValues = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseGroupQualifierRuleTypeID != undefined) {
                loaded.CourseGroupQualifierRuleTypeID(responseData.CourseGroupQualifierRuleTypeID);
            }
            if (responseData.CourseGroupQualifierBlockID != undefined) {
                loaded.CourseGroupQualifierBlockID(responseData.CourseGroupQualifierBlockID);
            }
            if (responseData.UnitOfMeasureID != undefined) {
                loaded.UnitOfMeasureID(responseData.UnitOfMeasureID);
            }
            if (responseData.PeriodOfCompletionUnitID != undefined) {
                loaded.PeriodOfCompletionUnitID(responseData.PeriodOfCompletionUnitID);
            }
            if (responseData.AcademicDepartmentID != undefined) {
                loaded.AcademicDepartmentID(responseData.AcademicDepartmentID);
            }
            if (responseData.AcademicSubjectAreaID != undefined) {
                loaded.AcademicSubjectAreaID(responseData.AcademicSubjectAreaID);
            }
            if (responseData.DegreeCourseGroupID != undefined) {
                loaded.DegreeCourseGroupID(responseData.DegreeCourseGroupID);
            }
            if (responseData.IntValue1 != undefined) {
                loaded.IntValue1(responseData.IntValue1);
            }
            if (responseData.IntValue2 != undefined) {
                loaded.IntValue2(responseData.IntValue2);
            }
            if (responseData.DoubleValue1 != undefined) {
                loaded.DoubleValue1(responseData.DoubleValue1);
            }
            if (responseData.DoubleValue2 != undefined) {
                loaded.DoubleValue2(responseData.DoubleValue2);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ComparisonOperator != undefined) {
                loaded.ComparisonOperator(responseData.ComparisonOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseGroupQualifierRuleType != null) {
                loaded.CourseGroupQualifierRuleType(new smapi.academic.CourseGroupQualifierRuleTypeModel().LoadFromResponse(responseData.CourseGroupQualifierRuleType));
            }
            if (responseData.CourseGroupQualifierBlock != null) {
                loaded.CourseGroupQualifierBlock(new smapi.academic.CourseGroupQualifierBlockModel().LoadFromResponse(responseData.CourseGroupQualifierBlock));
            }
            if (responseData.UnitOfMeasure != null) {
                loaded.UnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.UnitOfMeasure));
            }
            if (responseData.PeriodOfCompletionUnit != null) {
                loaded.PeriodOfCompletionUnit(new smapi.academic.PeriodOfCompletionUnitModel().LoadFromResponse(responseData.PeriodOfCompletionUnit));
            }
            if (responseData.AcademicDepartment != null) {
                loaded.AcademicDepartment(new smapi.academic.AcademicDepartmentModel().LoadFromResponse(responseData.AcademicDepartment));
            }
            if (responseData.AcademicSubjectArea != null) {
                loaded.AcademicSubjectArea(new smapi.academic.AcademicSubjectAreaModel().LoadFromResponse(responseData.AcademicSubjectArea));
            }
            if (responseData.DegreeCourseGroup != null) {
                loaded.DegreeCourseGroup(new smapi.academic.DegreeCourseGroupModel().LoadFromResponse(responseData.DegreeCourseGroup));
            }
            if (responseData.RuleValues != null && responseData.RuleValues.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RuleValues.length; i++) {
                    items.push(new smapi.academic.CourseGroupQualifierRuleValueModel().LoadFromResponse(responseData.RuleValues[i]));
                }
                loaded.RuleValues(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQualifierRule', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseGroupQualifierRuleTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseGroupQualifierBlockID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UnitOfMeasureID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodOfCompletionUnitID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicDepartmentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicSubjectAreaID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DegreeCourseGroupID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IntValue1.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IntValue2.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DoubleValue1.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DoubleValue2.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQualifierBlockModel(options) {
        var defaults = {
            DegreeRequirementID: 0,
            SortOrder: 0,
            Operator: null,
            OuterOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DegreeRequirementID = ko.validatedObservable(settings.DegreeRequirementID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.Operator = ko.validatedObservable(settings.Operator);
        this.OuterOperator = ko.validatedObservable(settings.OuterOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeRequirement = ko.observable();
        this.Rules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DegreeRequirementID != undefined) {
                loaded.DegreeRequirementID(responseData.DegreeRequirementID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.Operator != undefined) {
                loaded.Operator(responseData.Operator);
            }
            if (responseData.OuterOperator != undefined) {
                loaded.OuterOperator(responseData.OuterOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeRequirement != null) {
                loaded.DegreeRequirement(new smapi.academic.DegreeRequirementModel().LoadFromResponse(responseData.DegreeRequirement));
            }
            if (responseData.Rules != null && responseData.Rules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Rules.length; i++) {
                    items.push(new smapi.academic.CourseGroupQualifierRuleModel().LoadFromResponse(responseData.Rules[i]));
                }
                loaded.Rules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQualifierBlock', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DegreeRequirementID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Operator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.OuterOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQueryFilterValueModel(options) {
        var defaults = {
            CourseGroupQueryFilterID: 0,
            Value: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseGroupQueryFilterID = ko.validatedObservable(settings.CourseGroupQueryFilterID);
        this.Value = ko.validatedObservable(settings.Value);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseGroupQueryFilter = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseGroupQueryFilterID != undefined) {
                loaded.CourseGroupQueryFilterID(responseData.CourseGroupQueryFilterID);
            }
            if (responseData.Value != undefined) {
                loaded.Value(responseData.Value);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseGroupQueryFilter != null) {
                loaded.CourseGroupQueryFilter(new smapi.academic.CourseGroupQueryFilterModel().LoadFromResponse(responseData.CourseGroupQueryFilter));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQueryFilterValue', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseGroupQueryFilterID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Value.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQueryFilterModel(options) {
        var defaults = {
            CourseGroupQueryFilterTypeID: 0,
            CourseGroupQueryBlockID: 0,
            ComparisonOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseGroupQueryFilterTypeID = ko.validatedObservable(settings.CourseGroupQueryFilterTypeID);
        this.CourseGroupQueryBlockID = ko.validatedObservable(settings.CourseGroupQueryBlockID);
        this.ComparisonOperator = ko.validatedObservable(settings.ComparisonOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseGroupQueryFilterType = ko.observable();
        this.CourseGroupQueryBlock = ko.observable();
        this.Values = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseGroupQueryFilterTypeID != undefined) {
                loaded.CourseGroupQueryFilterTypeID(responseData.CourseGroupQueryFilterTypeID);
            }
            if (responseData.CourseGroupQueryBlockID != undefined) {
                loaded.CourseGroupQueryBlockID(responseData.CourseGroupQueryBlockID);
            }
            if (responseData.ComparisonOperator != undefined) {
                loaded.ComparisonOperator(responseData.ComparisonOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseGroupQueryFilterType != null) {
                loaded.CourseGroupQueryFilterType(new smapi.academic.CourseGroupQueryFilterTypeModel().LoadFromResponse(responseData.CourseGroupQueryFilterType));
            }
            if (responseData.CourseGroupQueryBlock != null) {
                loaded.CourseGroupQueryBlock(new smapi.academic.CourseGroupQueryBlockModel().LoadFromResponse(responseData.CourseGroupQueryBlock));
            }
            if (responseData.Values != null && responseData.Values.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Values.length; i++) {
                    items.push(new smapi.academic.CourseGroupQueryFilterValueModel().LoadFromResponse(responseData.Values[i]));
                }
                loaded.Values(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQueryFilter', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseGroupQueryFilterTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseGroupQueryBlockID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQueryBlockModel(options) {
        var defaults = {
            CourseGroupQueryID: 0,
            SortOrder: 0,
            Operator: null,
            ExternalOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseGroupQueryID = ko.validatedObservable(settings.CourseGroupQueryID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.Operator = ko.validatedObservable(settings.Operator);
        this.ExternalOperator = ko.validatedObservable(settings.ExternalOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseGroupQuery = ko.observable();
        this.Filters = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseGroupQueryID != undefined) {
                loaded.CourseGroupQueryID(responseData.CourseGroupQueryID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.Operator != undefined) {
                loaded.Operator(responseData.Operator);
            }
            if (responseData.ExternalOperator != undefined) {
                loaded.ExternalOperator(responseData.ExternalOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseGroupQuery != null) {
                loaded.CourseGroupQuery(new smapi.academic.CourseGroupQueryModel().LoadFromResponse(responseData.CourseGroupQuery));
            }
            if (responseData.Filters != null && responseData.Filters.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Filters.length; i++) {
                    items.push(new smapi.academic.CourseGroupQueryFilterModel().LoadFromResponse(responseData.Filters[i]));
                }
                loaded.Filters(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQueryBlock', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseGroupQueryID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Operator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ExternalOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseGroupQueryModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            DegreeCourseGroupID: 0,
            UnitOfMeasureID: 0,
            Units: 0,
            MinGPA: 0,
            Required: false,
            AllowTransfer: false,
            AllowEquivalent: false,
            Summarize: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.DegreeCourseGroupID = ko.validatedObservable(settings.DegreeCourseGroupID);
        this.UnitOfMeasureID = ko.validatedObservable(settings.UnitOfMeasureID);
        this.Units = ko.validatedObservable(settings.Units);
        this.MinGPA = ko.validatedObservable(settings.MinGPA);
        this.Required = ko.validatedObservable(settings.Required);
        this.AllowTransfer = ko.validatedObservable(settings.AllowTransfer);
        this.AllowEquivalent = ko.validatedObservable(settings.AllowEquivalent);
        this.Summarize = ko.validatedObservable(settings.Summarize);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.UnitOfMeasure = ko.observable();
        this.DegreeCourseGroup = ko.observable();
        this.Blocks = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.DegreeCourseGroupID != undefined) {
                loaded.DegreeCourseGroupID(responseData.DegreeCourseGroupID);
            }
            if (responseData.UnitOfMeasureID != undefined) {
                loaded.UnitOfMeasureID(responseData.UnitOfMeasureID);
            }
            if (responseData.Units != undefined) {
                loaded.Units(responseData.Units);
            }
            if (responseData.MinGPA != undefined) {
                loaded.MinGPA(responseData.MinGPA);
            }
            if (responseData.Required != undefined) {
                loaded.Required(responseData.Required);
            }
            if (responseData.AllowTransfer != undefined) {
                loaded.AllowTransfer(responseData.AllowTransfer);
            }
            if (responseData.AllowEquivalent != undefined) {
                loaded.AllowEquivalent(responseData.AllowEquivalent);
            }
            if (responseData.Summarize != undefined) {
                loaded.Summarize(responseData.Summarize);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.UnitOfMeasure != null) {
                loaded.UnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.UnitOfMeasure));
            }
            if (responseData.DegreeCourseGroup != null) {
                loaded.DegreeCourseGroup(new smapi.academic.DegreeCourseGroupModel().LoadFromResponse(responseData.DegreeCourseGroup));
            }
            if (responseData.Blocks != null && responseData.Blocks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Blocks.length; i++) {
                    items.push(new smapi.academic.CourseGroupQueryBlockModel().LoadFromResponse(responseData.Blocks[i]));
                }
                loaded.Blocks(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseGroupQuery', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.DegreeCourseGroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UnitOfMeasureID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Units.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinGPA.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeRequirementModel(options) {
        var defaults = {
            DegreeAuditID: 0,
            Name: '',
            Description: '',
            UnitOfMeasureID: null,
            MinUnits: 0,
            MinGPA: 0,
            PeriodOfCompletionValue: 0,
            PeriodOfCompletionUnitID: null,
            SortPriorityOrder: 0,
            Fulfilled: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DegreeAuditID = ko.validatedObservable(settings.DegreeAuditID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.UnitOfMeasureID = ko.validatedObservable(settings.UnitOfMeasureID);
        this.MinUnits = ko.validatedObservable(settings.MinUnits);
        this.MinGPA = ko.validatedObservable(settings.MinGPA);
        this.PeriodOfCompletionValue = ko.validatedObservable(settings.PeriodOfCompletionValue);
        this.PeriodOfCompletionUnitID = ko.validatedObservable(settings.PeriodOfCompletionUnitID);
        this.SortPriorityOrder = ko.validatedObservable(settings.SortPriorityOrder);
        this.Fulfilled = ko.validatedObservable(settings.Fulfilled);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeAudit = ko.observable();
        this.UnitOfMeasure = ko.observable();
        this.PeriodOfCompletionUnit = ko.observable();
        this.CourseGroups = ko.observableArray([]);
        this.RuleCriteriaForCourseGroups = ko.observableArray([]);
        this.Milestones = ko.observableArray([]);
        this.RuleCriteriaForMilestones = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DegreeAuditID != undefined) {
                loaded.DegreeAuditID(responseData.DegreeAuditID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.UnitOfMeasureID != undefined) {
                loaded.UnitOfMeasureID(responseData.UnitOfMeasureID);
            }
            if (responseData.MinUnits != undefined) {
                loaded.MinUnits(responseData.MinUnits);
            }
            if (responseData.MinGPA != undefined) {
                loaded.MinGPA(responseData.MinGPA);
            }
            if (responseData.PeriodOfCompletionValue != undefined) {
                loaded.PeriodOfCompletionValue(responseData.PeriodOfCompletionValue);
            }
            if (responseData.PeriodOfCompletionUnitID != undefined) {
                loaded.PeriodOfCompletionUnitID(responseData.PeriodOfCompletionUnitID);
            }
            if (responseData.SortPriorityOrder != undefined) {
                loaded.SortPriorityOrder(responseData.SortPriorityOrder);
            }
            if (responseData.Fulfilled != undefined) {
                loaded.Fulfilled(responseData.Fulfilled);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeAudit != null) {
                loaded.DegreeAudit(new smapi.academic.DegreeAuditModel().LoadFromResponse(responseData.DegreeAudit));
            }
            if (responseData.UnitOfMeasure != null) {
                loaded.UnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.UnitOfMeasure));
            }
            if (responseData.PeriodOfCompletionUnit != null) {
                loaded.PeriodOfCompletionUnit(new smapi.academic.PeriodOfCompletionUnitModel().LoadFromResponse(responseData.PeriodOfCompletionUnit));
            }
            if (responseData.CourseGroups != null && responseData.CourseGroups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.CourseGroups.length; i++) {
                    items.push(new smapi.academic.DegreeCourseGroupModel().LoadFromResponse(responseData.CourseGroups[i]));
                }
                loaded.CourseGroups(items);
            }
            if (responseData.RuleCriteriaForCourseGroups != null && responseData.RuleCriteriaForCourseGroups.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RuleCriteriaForCourseGroups.length; i++) {
                    items.push(new smapi.academic.CourseGroupQualifierBlockModel().LoadFromResponse(responseData.RuleCriteriaForCourseGroups[i]));
                }
                loaded.RuleCriteriaForCourseGroups(items);
            }
            if (responseData.Milestones != null && responseData.Milestones.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Milestones.length; i++) {
                    items.push(new smapi.academic.DegreeRequirementMilestoneModel().LoadFromResponse(responseData.Milestones[i]));
                }
                loaded.Milestones(items);
            }
            if (responseData.RuleCriteriaForMilestones != null && responseData.RuleCriteriaForMilestones.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RuleCriteriaForMilestones.length; i++) {
                    items.push(new smapi.academic.RequirementMilestoneRuleBlockModel().LoadFromResponse(responseData.RuleCriteriaForMilestones[i]));
                }
                loaded.RuleCriteriaForMilestones(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeRequirement', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DegreeAuditID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.UnitOfMeasureID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinUnits.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinGPA.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodOfCompletionValue.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodOfCompletionUnitID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortPriorityOrder.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeRequirementQualifierRuleModel(options) {
        var defaults = {
            DegreeRequirementQualifierBlockID: 0,
            SortOrder: 0,
            DegreeRequirementID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DegreeRequirementQualifierBlockID = ko.validatedObservable(settings.DegreeRequirementQualifierBlockID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.DegreeRequirementID = ko.validatedObservable(settings.DegreeRequirementID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeRequirementQualifierBlock = ko.observable();
        this.DegreeRequirement = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DegreeRequirementQualifierBlockID != undefined) {
                loaded.DegreeRequirementQualifierBlockID(responseData.DegreeRequirementQualifierBlockID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.DegreeRequirementID != undefined) {
                loaded.DegreeRequirementID(responseData.DegreeRequirementID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeRequirementQualifierBlock != null) {
                loaded.DegreeRequirementQualifierBlock(new smapi.academic.DegreeRequirementQualifierBlockModel().LoadFromResponse(responseData.DegreeRequirementQualifierBlock));
            }
            if (responseData.DegreeRequirement != null) {
                loaded.DegreeRequirement(new smapi.academic.DegreeRequirementModel().LoadFromResponse(responseData.DegreeRequirement));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeRequirementQualifierRule', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DegreeRequirementQualifierBlockID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DegreeRequirementID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeRequirementQualifierBlockModel(options) {
        var defaults = {
            DegreeAuditID: 0,
            SortOrder: 0,
            OuterOperator: null,
            InnerOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DegreeAuditID = ko.validatedObservable(settings.DegreeAuditID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.OuterOperator = ko.validatedObservable(settings.OuterOperator);
        this.InnerOperator = ko.validatedObservable(settings.InnerOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeAudit = ko.observable();
        this.Rules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DegreeAuditID != undefined) {
                loaded.DegreeAuditID(responseData.DegreeAuditID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.OuterOperator != undefined) {
                loaded.OuterOperator(responseData.OuterOperator);
            }
            if (responseData.InnerOperator != undefined) {
                loaded.InnerOperator(responseData.InnerOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeAudit != null) {
                loaded.DegreeAudit(new smapi.academic.DegreeAuditModel().LoadFromResponse(responseData.DegreeAudit));
            }
            if (responseData.Rules != null && responseData.Rules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Rules.length; i++) {
                    items.push(new smapi.academic.DegreeRequirementQualifierRuleModel().LoadFromResponse(responseData.Rules[i]));
                }
                loaded.Rules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeRequirementQualifierBlock', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DegreeAuditID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OuterOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InnerOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeAuditHistoryDetailModel(options) {
        var defaults = {
            DegreeAuditHistoryID: null,
            Action: '',
            Path: '',
            ObjectType: '',
            OldValue: '',
            NewValue: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DegreeAuditHistoryID = ko.validatedObservable(settings.DegreeAuditHistoryID);
        this.Action = ko.validatedObservable(settings.Action);
        this.Path = ko.validatedObservable(settings.Path);
        this.ObjectType = ko.validatedObservable(settings.ObjectType);
        this.OldValue = ko.validatedObservable(settings.OldValue);
        this.NewValue = ko.validatedObservable(settings.NewValue);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeAuditHistory = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DegreeAuditHistoryID != undefined) {
                loaded.DegreeAuditHistoryID(responseData.DegreeAuditHistoryID);
            }
            if (responseData.Action != undefined) {
                loaded.Action(responseData.Action);
            }
            if (responseData.Path != undefined) {
                loaded.Path(responseData.Path);
            }
            if (responseData.ObjectType != undefined) {
                loaded.ObjectType(responseData.ObjectType);
            }
            if (responseData.OldValue != undefined) {
                loaded.OldValue(responseData.OldValue);
            }
            if (responseData.NewValue != undefined) {
                loaded.NewValue(responseData.NewValue);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeAuditHistory != null) {
                loaded.DegreeAuditHistory(new smapi.academic.DegreeAuditHistoryModel().LoadFromResponse(responseData.DegreeAuditHistory));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeAuditHistoryDetail', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DegreeAuditHistoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Action.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Path.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ObjectType.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.OldValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.NewValue.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeAuditHistoryModel(options) {
        var defaults = {
            Comment: '',
            DegreeAuditID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Comment = ko.validatedObservable(settings.Comment);
        this.DegreeAuditID = ko.validatedObservable(settings.DegreeAuditID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeAudit = ko.observable();
        this.Details = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Comment != undefined) {
                loaded.Comment(responseData.Comment);
            }
            if (responseData.DegreeAuditID != undefined) {
                loaded.DegreeAuditID(responseData.DegreeAuditID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeAudit != null) {
                loaded.DegreeAudit(new smapi.academic.DegreeAuditModel().LoadFromResponse(responseData.DegreeAudit));
            }
            if (responseData.Details != null && responseData.Details.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Details.length; i++) {
                    items.push(new smapi.academic.DegreeAuditHistoryDetailModel().LoadFromResponse(responseData.Details[i]));
                }
                loaded.Details(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeAuditHistory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Comment.extend({
            maxLength: {
                params: 2000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '2000')
            }
        });
        this.DegreeAuditID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeAuditModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ProgramID: 0,
            GoalID: 0,
            Version: '',
            StartDate: null,
            EndDate: null,
            DefaultUnitOfMeasureID: null,
            DefaultMatchLimit: 0,
            DefaultSummarize: false,
            UnitOfMeasureID: null,
            MinUnits: 0,
            MinGPA: 0,
            PeriodOfCompletionValue: 0,
            PeriodOfCompletionUnitID: null,
            CurrentSchoolCompletionUnitOfMeasureID: null,
            CurrentSchoolCompletionTotal: 0,
            CurrentSchoolCompletionMin: 0,
            BusinessMeaningName: '',
            OverridesID: null,
            StudentID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ProgramID = ko.validatedObservable(settings.ProgramID);
        this.GoalID = ko.validatedObservable(settings.GoalID);
        this.Version = ko.validatedObservable(settings.Version);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.DefaultUnitOfMeasureID = ko.validatedObservable(settings.DefaultUnitOfMeasureID);
        this.DefaultMatchLimit = ko.validatedObservable(settings.DefaultMatchLimit);
        this.DefaultSummarize = ko.validatedObservable(settings.DefaultSummarize);
        this.UnitOfMeasureID = ko.validatedObservable(settings.UnitOfMeasureID);
        this.MinUnits = ko.validatedObservable(settings.MinUnits);
        this.MinGPA = ko.validatedObservable(settings.MinGPA);
        this.PeriodOfCompletionValue = ko.validatedObservable(settings.PeriodOfCompletionValue);
        this.PeriodOfCompletionUnitID = ko.validatedObservable(settings.PeriodOfCompletionUnitID);
        this.CurrentSchoolCompletionUnitOfMeasureID = ko.validatedObservable(settings.CurrentSchoolCompletionUnitOfMeasureID);
        this.CurrentSchoolCompletionTotal = ko.validatedObservable(settings.CurrentSchoolCompletionTotal);
        this.CurrentSchoolCompletionMin = ko.validatedObservable(settings.CurrentSchoolCompletionMin);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.OverridesID = ko.validatedObservable(settings.OverridesID);
        this.StudentID = ko.validatedObservable(settings.StudentID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Overrides = ko.observable();
        this.Student = ko.observable();
        this.Program = ko.observable();
        this.Goal = ko.observable();
        this.DefaultUnitOfMeasure = ko.observable();
        this.CurrentSchoolCompletionUnitOfMeasure = ko.observable();
        this.UnitOfMeasure = ko.observable();
        this.PeriodOfCompletionUnit = ko.observable();
        this.Requirements = ko.observableArray([]);
        this.RuleBlocks = ko.observableArray([]);
        this.History = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ProgramID != undefined) {
                loaded.ProgramID(responseData.ProgramID);
            }
            if (responseData.GoalID != undefined) {
                loaded.GoalID(responseData.GoalID);
            }
            if (responseData.Version != undefined) {
                loaded.Version(responseData.Version);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.DefaultUnitOfMeasureID != undefined) {
                loaded.DefaultUnitOfMeasureID(responseData.DefaultUnitOfMeasureID);
            }
            if (responseData.DefaultMatchLimit != undefined) {
                loaded.DefaultMatchLimit(responseData.DefaultMatchLimit);
            }
            if (responseData.DefaultSummarize != undefined) {
                loaded.DefaultSummarize(responseData.DefaultSummarize);
            }
            if (responseData.UnitOfMeasureID != undefined) {
                loaded.UnitOfMeasureID(responseData.UnitOfMeasureID);
            }
            if (responseData.MinUnits != undefined) {
                loaded.MinUnits(responseData.MinUnits);
            }
            if (responseData.MinGPA != undefined) {
                loaded.MinGPA(responseData.MinGPA);
            }
            if (responseData.PeriodOfCompletionValue != undefined) {
                loaded.PeriodOfCompletionValue(responseData.PeriodOfCompletionValue);
            }
            if (responseData.PeriodOfCompletionUnitID != undefined) {
                loaded.PeriodOfCompletionUnitID(responseData.PeriodOfCompletionUnitID);
            }
            if (responseData.CurrentSchoolCompletionUnitOfMeasureID != undefined) {
                loaded.CurrentSchoolCompletionUnitOfMeasureID(responseData.CurrentSchoolCompletionUnitOfMeasureID);
            }
            if (responseData.CurrentSchoolCompletionTotal != undefined) {
                loaded.CurrentSchoolCompletionTotal(responseData.CurrentSchoolCompletionTotal);
            }
            if (responseData.CurrentSchoolCompletionMin != undefined) {
                loaded.CurrentSchoolCompletionMin(responseData.CurrentSchoolCompletionMin);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.OverridesID != undefined) {
                loaded.OverridesID(responseData.OverridesID);
            }
            if (responseData.StudentID != undefined) {
                loaded.StudentID(responseData.StudentID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Overrides != null) {
                loaded.Overrides(new smapi.academic.DegreeAuditModel().LoadFromResponse(responseData.Overrides));
            }
            if (responseData.Student != null) {
                loaded.Student(new smapi.academic.StudentModel().LoadFromResponse(responseData.Student));
            }
            if (responseData.Program != null) {
                loaded.Program(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.Program));
            }
            if (responseData.Goal != null) {
                loaded.Goal(new smapi.academic.EducationalGoalModel().LoadFromResponse(responseData.Goal));
            }
            if (responseData.DefaultUnitOfMeasure != null) {
                loaded.DefaultUnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.DefaultUnitOfMeasure));
            }
            if (responseData.CurrentSchoolCompletionUnitOfMeasure != null) {
                loaded.CurrentSchoolCompletionUnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.CurrentSchoolCompletionUnitOfMeasure));
            }
            if (responseData.UnitOfMeasure != null) {
                loaded.UnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.UnitOfMeasure));
            }
            if (responseData.PeriodOfCompletionUnit != null) {
                loaded.PeriodOfCompletionUnit(new smapi.academic.PeriodOfCompletionUnitModel().LoadFromResponse(responseData.PeriodOfCompletionUnit));
            }
            if (responseData.Requirements != null && responseData.Requirements.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Requirements.length; i++) {
                    items.push(new smapi.academic.DegreeRequirementModel().LoadFromResponse(responseData.Requirements[i]));
                }
                loaded.Requirements(items);
            }
            if (responseData.RuleBlocks != null && responseData.RuleBlocks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.RuleBlocks.length; i++) {
                    items.push(new smapi.academic.DegreeRequirementQualifierBlockModel().LoadFromResponse(responseData.RuleBlocks[i]));
                }
                loaded.RuleBlocks(items);
            }
            if (responseData.History != null && responseData.History.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.History.length; i++) {
                    items.push(new smapi.academic.DegreeAuditHistoryModel().LoadFromResponse(responseData.History[i]));
                }
                loaded.History(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeAudit', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ProgramID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GoalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Version.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.DefaultUnitOfMeasureID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DefaultMatchLimit.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UnitOfMeasureID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinUnits.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MinGPA.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodOfCompletionValue.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodOfCompletionUnitID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CurrentSchoolCompletionUnitOfMeasureID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CurrentSchoolCompletionTotal.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CurrentSchoolCompletionMin.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.OverridesID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StudentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeAuditMilestoneTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeAuditMilestoneType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicMilestoneTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            MilestoneTypeID: 0,
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.MilestoneTypeID = ko.validatedObservable(settings.MilestoneTypeID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MilestoneType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.MilestoneTypeID != undefined) {
                loaded.MilestoneTypeID(responseData.MilestoneTypeID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MilestoneType != null) {
                loaded.MilestoneType(new smapi.academic.DegreeAuditMilestoneTypeModel().LoadFromResponse(responseData.MilestoneType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicMilestoneType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MilestoneTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeRequirementMilestoneTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            MilestoneTypeID: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.MilestoneTypeID = ko.validatedObservable(settings.MilestoneTypeID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MilestoneType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.MilestoneTypeID != undefined) {
                loaded.MilestoneTypeID(responseData.MilestoneTypeID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MilestoneType != null) {
                loaded.MilestoneType(new smapi.academic.DegreeAuditMilestoneTypeModel().LoadFromResponse(responseData.MilestoneType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeRequirementMilestoneType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.MilestoneTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function DegreeRequirementMilestoneModel(options) {
        var defaults = {
            DegreeRequirementID: 0,
            MilestoneTypeID: 0,
            Name: '',
            Description: '',
            Fulfilled: false,
            AcademicMilestoneTypeID: 0,
            PeriodOfCompletionValue: 0,
            PeriodOfCompletionUnitID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DegreeRequirementID = ko.validatedObservable(settings.DegreeRequirementID);
        this.MilestoneTypeID = ko.validatedObservable(settings.MilestoneTypeID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.Fulfilled = ko.validatedObservable(settings.Fulfilled);
        this.AcademicMilestoneTypeID = ko.validatedObservable(settings.AcademicMilestoneTypeID);
        this.PeriodOfCompletionValue = ko.validatedObservable(settings.PeriodOfCompletionValue);
        this.PeriodOfCompletionUnitID = ko.validatedObservable(settings.PeriodOfCompletionUnitID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeRequirement = ko.observable();
        this.MilestoneType = ko.observable();
        this.AcademicMilestoneType = ko.observable();
        this.PeriodOfCompletionUnit = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DegreeRequirementID != undefined) {
                loaded.DegreeRequirementID(responseData.DegreeRequirementID);
            }
            if (responseData.MilestoneTypeID != undefined) {
                loaded.MilestoneTypeID(responseData.MilestoneTypeID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.Fulfilled != undefined) {
                loaded.Fulfilled(responseData.Fulfilled);
            }
            if (responseData.AcademicMilestoneTypeID != undefined) {
                loaded.AcademicMilestoneTypeID(responseData.AcademicMilestoneTypeID);
            }
            if (responseData.PeriodOfCompletionValue != undefined) {
                loaded.PeriodOfCompletionValue(responseData.PeriodOfCompletionValue);
            }
            if (responseData.PeriodOfCompletionUnitID != undefined) {
                loaded.PeriodOfCompletionUnitID(responseData.PeriodOfCompletionUnitID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeRequirement != null) {
                loaded.DegreeRequirement(new smapi.academic.DegreeRequirementModel().LoadFromResponse(responseData.DegreeRequirement));
            }
            if (responseData.MilestoneType != null) {
                loaded.MilestoneType(new smapi.academic.DegreeAuditMilestoneTypeModel().LoadFromResponse(responseData.MilestoneType));
            }
            if (responseData.AcademicMilestoneType != null) {
                loaded.AcademicMilestoneType(new smapi.academic.AcademicMilestoneTypeModel().LoadFromResponse(responseData.AcademicMilestoneType));
            }
            if (responseData.PeriodOfCompletionUnit != null) {
                loaded.PeriodOfCompletionUnit(new smapi.academic.PeriodOfCompletionUnitModel().LoadFromResponse(responseData.PeriodOfCompletionUnit));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.DegreeRequirementMilestone', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DegreeRequirementID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.AcademicMilestoneTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodOfCompletionValue.extend({
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PeriodOfCompletionUnitID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequirementMilestoneRuleModel(options) {
        var defaults = {
            MilestoneRuleBlockID: 0,
            MilestoneID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.MilestoneRuleBlockID = ko.validatedObservable(settings.MilestoneRuleBlockID);
        this.MilestoneID = ko.validatedObservable(settings.MilestoneID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.MilestoneRuleBlock = ko.observable();
        this.Milestone = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.MilestoneRuleBlockID != undefined) {
                loaded.MilestoneRuleBlockID(responseData.MilestoneRuleBlockID);
            }
            if (responseData.MilestoneID != undefined) {
                loaded.MilestoneID(responseData.MilestoneID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.MilestoneRuleBlock != null) {
                loaded.MilestoneRuleBlock(new smapi.academic.RequirementMilestoneRuleBlockModel().LoadFromResponse(responseData.MilestoneRuleBlock));
            }
            if (responseData.Milestone != null) {
                loaded.Milestone(new smapi.academic.DegreeRequirementMilestoneModel().LoadFromResponse(responseData.Milestone));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.RequirementMilestoneRule', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.MilestoneRuleBlockID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MilestoneID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function RequirementMilestoneRuleBlockModel(options) {
        var defaults = {
            DegreeRequirementID: 0,
            ExternalOperator: null,
            InternalOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.DegreeRequirementID = ko.validatedObservable(settings.DegreeRequirementID);
        this.ExternalOperator = ko.validatedObservable(settings.ExternalOperator);
        this.InternalOperator = ko.validatedObservable(settings.InternalOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.DegreeRequirement = ko.observable();
        this.Rules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.DegreeRequirementID != undefined) {
                loaded.DegreeRequirementID(responseData.DegreeRequirementID);
            }
            if (responseData.ExternalOperator != undefined) {
                loaded.ExternalOperator(responseData.ExternalOperator);
            }
            if (responseData.InternalOperator != undefined) {
                loaded.InternalOperator(responseData.InternalOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.DegreeRequirement != null) {
                loaded.DegreeRequirement(new smapi.academic.DegreeRequirementModel().LoadFromResponse(responseData.DegreeRequirement));
            }
            if (responseData.Rules != null && responseData.Rules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Rules.length; i++) {
                    items.push(new smapi.academic.RequirementMilestoneRuleModel().LoadFromResponse(responseData.Rules[i]));
                }
                loaded.Rules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.RequirementMilestoneRuleBlock', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.DegreeRequirementID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ExternalOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.InternalOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicReportingCodeTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicReportingCodeType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicReportingCodeModel(options) {
        var defaults = {
            AcademicProgramID: null,
            Name: '',
            Description: '',
            BeginDate: null,
            EndDate: null,
            ReportCodeTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicProgramID = ko.validatedObservable(settings.AcademicProgramID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ReportCodeTypeID = ko.validatedObservable(settings.ReportCodeTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ReportCodeType = ko.observable();
        this.AcademicProgram = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicProgramID != undefined) {
                loaded.AcademicProgramID(responseData.AcademicProgramID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ReportCodeTypeID != undefined) {
                loaded.ReportCodeTypeID(responseData.ReportCodeTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ReportCodeType != null) {
                loaded.ReportCodeType(new smapi.academic.AcademicReportingCodeTypeModel().LoadFromResponse(responseData.ReportCodeType));
            }
            if (responseData.AcademicProgram != null) {
                loaded.AcademicProgram(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.AcademicProgram));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicReportingCode', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ReportCodeTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ExternalAcademicReportingCodeModel(options) {
        var defaults = {
            ExternalAcademicProgramID: null,
            Name: '',
            Description: '',
            BeginDate: null,
            EndDate: null,
            ReportCodeTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.ExternalAcademicProgramID = ko.validatedObservable(settings.ExternalAcademicProgramID);
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BeginDate = ko.validatedObservable(settings.BeginDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.ReportCodeTypeID = ko.validatedObservable(settings.ReportCodeTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.ReportCodeType = ko.observable();
        this.ExternalAcademicProgram = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.ExternalAcademicProgramID != undefined) {
                loaded.ExternalAcademicProgramID(responseData.ExternalAcademicProgramID);
            }
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BeginDate != undefined) {
                loaded.BeginDate(responseData.BeginDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.ReportCodeTypeID != undefined) {
                loaded.ReportCodeTypeID(responseData.ReportCodeTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.ReportCodeType != null) {
                loaded.ReportCodeType(new smapi.academic.AcademicReportingCodeTypeModel().LoadFromResponse(responseData.ReportCodeType));
            }
            if (responseData.ExternalAcademicProgram != null) {
                loaded.ExternalAcademicProgram(new smapi.academic.ExternalAcademicProgramModel().LoadFromResponse(responseData.ExternalAcademicProgram));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ExternalAcademicReportingCode', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.ExternalAcademicProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.ReportCodeTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function FundingSourceModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            FundBeginDate: null,
            FundEndDate: null,
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.FundBeginDate = ko.validatedObservable(settings.FundBeginDate);
        this.FundEndDate = ko.validatedObservable(settings.FundEndDate);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.FundBeginDate != undefined) {
                loaded.FundBeginDate(responseData.FundBeginDate);
            }
            if (responseData.FundEndDate != undefined) {
                loaded.FundEndDate(responseData.FundEndDate);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.FundingSource', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FundBeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.FundEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseMasterFundingSourceModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            FundBeginDate: null,
            FundEndDate: null,
            FundingSourceID: 0,
            OrganizationID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.FundBeginDate = ko.validatedObservable(settings.FundBeginDate);
        this.FundEndDate = ko.validatedObservable(settings.FundEndDate);
        this.FundingSourceID = ko.validatedObservable(settings.FundingSourceID);
        this.OrganizationID = ko.validatedObservable(settings.OrganizationID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.FundSource = ko.observable();
        this.Organization = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.FundBeginDate != undefined) {
                loaded.FundBeginDate(responseData.FundBeginDate);
            }
            if (responseData.FundEndDate != undefined) {
                loaded.FundEndDate(responseData.FundEndDate);
            }
            if (responseData.FundingSourceID != undefined) {
                loaded.FundingSourceID(responseData.FundingSourceID);
            }
            if (responseData.OrganizationID != undefined) {
                loaded.OrganizationID(responseData.OrganizationID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.FundSource != null) {
                loaded.FundSource(new smapi.academic.FundingSourceModel().LoadFromResponse(responseData.FundSource));
            }
            if (responseData.Organization != null) {
                loaded.Organization(new smapi.community.OrganizationModel().LoadFromResponse(responseData.Organization));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseMasterFundingSource', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.FundBeginDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.FundEndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.FundingSourceID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.OrganizationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SAPConfigurationScopeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            EnrollmentLoadID: null,
            AcademicLevelID: null,
            ProgramCategoryID: null,
            AcademicProgramID: null,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.EnrollmentLoadID = ko.validatedObservable(settings.EnrollmentLoadID);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.ProgramCategoryID = ko.validatedObservable(settings.ProgramCategoryID);
        this.AcademicProgramID = ko.validatedObservable(settings.AcademicProgramID);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.EnrollmentLoad = ko.observable();
        this.AcademicLevel = ko.observable();
        this.ProgramCategory = ko.observable();
        this.AcademicProgram = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.EnrollmentLoadID != undefined) {
                loaded.EnrollmentLoadID(responseData.EnrollmentLoadID);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.ProgramCategoryID != undefined) {
                loaded.ProgramCategoryID(responseData.ProgramCategoryID);
            }
            if (responseData.AcademicProgramID != undefined) {
                loaded.AcademicProgramID(responseData.AcademicProgramID);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.EnrollmentLoad != null) {
                loaded.EnrollmentLoad(new smapi.academic.EnrollmentLoadModel().LoadFromResponse(responseData.EnrollmentLoad));
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.ProgramCategory != null) {
                loaded.ProgramCategory(new smapi.academic.ProgramCategoryModel().LoadFromResponse(responseData.ProgramCategory));
            }
            if (responseData.AcademicProgram != null) {
                loaded.AcademicProgram(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.AcademicProgram));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.SAPConfigurationScope', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EnrollmentLoadID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicLevelID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProgramCategoryID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicProgramID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPlanStepTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPlanStepType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPlanStepModel(options) {
        var defaults = {
            Name: '',
            StepTypeID: null,
            StepMet: false,
            StepMetApproved: false,
            StepMetApprovedByID: null,
            StepDetails: '',
            AcademicPlanID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.StepTypeID = ko.validatedObservable(settings.StepTypeID);
        this.StepMet = ko.validatedObservable(settings.StepMet);
        this.StepMetApproved = ko.validatedObservable(settings.StepMetApproved);
        this.StepMetApprovedByID = ko.validatedObservable(settings.StepMetApprovedByID);
        this.StepDetails = ko.validatedObservable(settings.StepDetails);
        this.AcademicPlanID = ko.validatedObservable(settings.AcademicPlanID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.StepMetApprovedBy = ko.observable();
        this.AcademicPlan = ko.observable();
        this.StepType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.StepTypeID != undefined) {
                loaded.StepTypeID(responseData.StepTypeID);
            }
            if (responseData.StepMet != undefined) {
                loaded.StepMet(responseData.StepMet);
            }
            if (responseData.StepMetApproved != undefined) {
                loaded.StepMetApproved(responseData.StepMetApproved);
            }
            if (responseData.StepMetApprovedByID != undefined) {
                loaded.StepMetApprovedByID(responseData.StepMetApprovedByID);
            }
            if (responseData.StepDetails != undefined) {
                loaded.StepDetails(responseData.StepDetails);
            }
            if (responseData.AcademicPlanID != undefined) {
                loaded.AcademicPlanID(responseData.AcademicPlanID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.StepMetApprovedBy != null) {
                loaded.StepMetApprovedBy(new smapi.entities.UserModel().LoadFromResponse(responseData.StepMetApprovedBy));
            }
            if (responseData.AcademicPlan != null) {
                loaded.AcademicPlan(new smapi.academic.AcademicPlanModel().LoadFromResponse(responseData.AcademicPlan));
            }
            if (responseData.StepType != null) {
                loaded.StepType(new smapi.academic.AcademicPlanStepTypeModel().LoadFromResponse(responseData.StepType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPlanStep', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.StepTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StepMetApprovedByID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicPlanModel(options) {
        var defaults = {
            StudentID: null,
            PlanMet: false,
            PlanMetApproved: false,
            PlanMetApprovedByID: null,
            AcademicPeriodID: null,
            StartDate: null,
            EndDate: null,
            AcademicRequirementID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.StudentID = ko.validatedObservable(settings.StudentID);
        this.PlanMet = ko.validatedObservable(settings.PlanMet);
        this.PlanMetApproved = ko.validatedObservable(settings.PlanMetApproved);
        this.PlanMetApprovedByID = ko.validatedObservable(settings.PlanMetApprovedByID);
        this.AcademicPeriodID = ko.validatedObservable(settings.AcademicPeriodID);
        this.StartDate = ko.validatedObservable(settings.StartDate);
        this.EndDate = ko.validatedObservable(settings.EndDate);
        this.AcademicRequirementID = ko.validatedObservable(settings.AcademicRequirementID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Student = ko.observable();
        this.PlanMetApprovedBy = ko.observable();
        this.AcademicRequirement = ko.observable();
        this.Steps = ko.observableArray([]);
        this.AcademicPeriod = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.StudentID != undefined) {
                loaded.StudentID(responseData.StudentID);
            }
            if (responseData.PlanMet != undefined) {
                loaded.PlanMet(responseData.PlanMet);
            }
            if (responseData.PlanMetApproved != undefined) {
                loaded.PlanMetApproved(responseData.PlanMetApproved);
            }
            if (responseData.PlanMetApprovedByID != undefined) {
                loaded.PlanMetApprovedByID(responseData.PlanMetApprovedByID);
            }
            if (responseData.AcademicPeriodID != undefined) {
                loaded.AcademicPeriodID(responseData.AcademicPeriodID);
            }
            if (responseData.StartDate != undefined) {
                loaded.StartDate(responseData.StartDate);
            }
            if (responseData.EndDate != undefined) {
                loaded.EndDate(responseData.EndDate);
            }
            if (responseData.AcademicRequirementID != undefined) {
                loaded.AcademicRequirementID(responseData.AcademicRequirementID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Student != null) {
                loaded.Student(new smapi.academic.StudentModel().LoadFromResponse(responseData.Student));
            }
            if (responseData.PlanMetApprovedBy != null) {
                loaded.PlanMetApprovedBy(new smapi.entities.UserModel().LoadFromResponse(responseData.PlanMetApprovedBy));
            }
            if (responseData.AcademicRequirement != null) {
                loaded.AcademicRequirement(new smapi.academic.AcademicRequirementModel().LoadFromResponse(responseData.AcademicRequirement));
            }
            if (responseData.Steps != null && responseData.Steps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Steps.length; i++) {
                    items.push(new smapi.academic.AcademicPlanStepModel().LoadFromResponse(responseData.Steps[i]));
                }
                loaded.Steps(items);
            }
            if (responseData.AcademicPeriod != null) {
                loaded.AcademicPeriod(new smapi.academic.AcademicPeriodModel().LoadFromResponse(responseData.AcademicPeriod));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicPlan', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.StudentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PlanMetApprovedByID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicPeriodID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StartDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EndDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.AcademicRequirementID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicStatusAppealReasonModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            RequiresExplanation: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.RequiresExplanation = ko.validatedObservable(settings.RequiresExplanation);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.RequiresExplanation != undefined) {
                loaded.RequiresExplanation(responseData.RequiresExplanation);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicStatusAppealReason', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressStandingTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SystemProtected: false,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressStandingType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicAwardTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicAwardType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            ClassType: 0,
            SortOrder: 0,
            StopRegistration: false,
            StopOnlineRegistration: false,
            StopTranscript: false,
            StopGradeCard: false,
            StopStatement: false,
            AllowAppeal: false,
            CSSClassName: '',
            Occurrence: 0,
            BusinessMeaningName: '',
            HoldTypeID: null,
            StandingTypeID: 0,
            AcademicAchievementTypeID: null,
            SAPScopeID: null,
            Frequency: null,
            GradeEffectTypeID: null,
            RepeatPolicyID: null,
            EvaluationMonth: 0,
            EvaluationDayOfMonth: 0,
            RemedialCourses: false,
            MaxResetCount: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.ClassType = ko.validatedObservable(settings.ClassType);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.StopRegistration = ko.validatedObservable(settings.StopRegistration);
        this.StopOnlineRegistration = ko.validatedObservable(settings.StopOnlineRegistration);
        this.StopTranscript = ko.validatedObservable(settings.StopTranscript);
        this.StopGradeCard = ko.validatedObservable(settings.StopGradeCard);
        this.StopStatement = ko.validatedObservable(settings.StopStatement);
        this.AllowAppeal = ko.validatedObservable(settings.AllowAppeal);
        this.CSSClassName = ko.validatedObservable(settings.CSSClassName);
        this.Occurrence = ko.validatedObservable(settings.Occurrence);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.HoldTypeID = ko.validatedObservable(settings.HoldTypeID);
        this.StandingTypeID = ko.validatedObservable(settings.StandingTypeID);
        this.AcademicAchievementTypeID = ko.validatedObservable(settings.AcademicAchievementTypeID);
        this.SAPScopeID = ko.validatedObservable(settings.SAPScopeID);
        this.Frequency = ko.validatedObservable(settings.Frequency);
        this.GradeEffectTypeID = ko.validatedObservable(settings.GradeEffectTypeID);
        this.RepeatPolicyID = ko.validatedObservable(settings.RepeatPolicyID);
        this.EvaluationMonth = ko.validatedObservable(settings.EvaluationMonth);
        this.EvaluationDayOfMonth = ko.validatedObservable(settings.EvaluationDayOfMonth);
        this.RemedialCourses = ko.validatedObservable(settings.RemedialCourses);
        this.MaxResetCount = ko.validatedObservable(settings.MaxResetCount);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.HoldType = ko.observable();
        this.StandingType = ko.observable();
        this.AchievementType = ko.observable();
        this.NextSteps = ko.observableArray([]);
        this.QualifierBlocks = ko.observableArray([]);
        this.SAPScope = ko.observable();
        this.GradeEffectType = ko.observable();
        this.RepeatPolicy = ko.observable();
        this.EvaluationPeriodTypes = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.ClassType != undefined) {
                loaded.ClassType(responseData.ClassType);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.StopRegistration != undefined) {
                loaded.StopRegistration(responseData.StopRegistration);
            }
            if (responseData.StopOnlineRegistration != undefined) {
                loaded.StopOnlineRegistration(responseData.StopOnlineRegistration);
            }
            if (responseData.StopTranscript != undefined) {
                loaded.StopTranscript(responseData.StopTranscript);
            }
            if (responseData.StopGradeCard != undefined) {
                loaded.StopGradeCard(responseData.StopGradeCard);
            }
            if (responseData.StopStatement != undefined) {
                loaded.StopStatement(responseData.StopStatement);
            }
            if (responseData.AllowAppeal != undefined) {
                loaded.AllowAppeal(responseData.AllowAppeal);
            }
            if (responseData.CSSClassName != undefined) {
                loaded.CSSClassName(responseData.CSSClassName);
            }
            if (responseData.Occurrence != undefined) {
                loaded.Occurrence(responseData.Occurrence);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.HoldTypeID != undefined) {
                loaded.HoldTypeID(responseData.HoldTypeID);
            }
            if (responseData.StandingTypeID != undefined) {
                loaded.StandingTypeID(responseData.StandingTypeID);
            }
            if (responseData.AcademicAchievementTypeID != undefined) {
                loaded.AcademicAchievementTypeID(responseData.AcademicAchievementTypeID);
            }
            if (responseData.SAPScopeID != undefined) {
                loaded.SAPScopeID(responseData.SAPScopeID);
            }
            if (responseData.Frequency != undefined) {
                loaded.Frequency(responseData.Frequency);
            }
            if (responseData.GradeEffectTypeID != undefined) {
                loaded.GradeEffectTypeID(responseData.GradeEffectTypeID);
            }
            if (responseData.RepeatPolicyID != undefined) {
                loaded.RepeatPolicyID(responseData.RepeatPolicyID);
            }
            if (responseData.EvaluationMonth != undefined) {
                loaded.EvaluationMonth(responseData.EvaluationMonth);
            }
            if (responseData.EvaluationDayOfMonth != undefined) {
                loaded.EvaluationDayOfMonth(responseData.EvaluationDayOfMonth);
            }
            if (responseData.RemedialCourses != undefined) {
                loaded.RemedialCourses(responseData.RemedialCourses);
            }
            if (responseData.MaxResetCount != undefined) {
                loaded.MaxResetCount(responseData.MaxResetCount);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.HoldType != null) {
                loaded.HoldType(new smapi.community.HoldCategoryModel().LoadFromResponse(responseData.HoldType));
            }
            if (responseData.StandingType != null) {
                loaded.StandingType(new smapi.academic.AcademicProgressStandingTypeModel().LoadFromResponse(responseData.StandingType));
            }
            if (responseData.AchievementType != null) {
                loaded.AchievementType(new smapi.academic.AcademicAwardTypeModel().LoadFromResponse(responseData.AchievementType));
            }
            if (responseData.NextSteps != null && responseData.NextSteps.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.NextSteps.length; i++) {
                    items.push(new smapi.academic.AcademicProgressStatusFlowModel().LoadFromResponse(responseData.NextSteps[i]));
                }
                loaded.NextSteps(items);
            }
            if (responseData.QualifierBlocks != null && responseData.QualifierBlocks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QualifierBlocks.length; i++) {
                    items.push(new smapi.academic.AcademicProgressStatusBlockModel().LoadFromResponse(responseData.QualifierBlocks[i]));
                }
                loaded.QualifierBlocks(items);
            }
            if (responseData.SAPScope != null) {
                loaded.SAPScope(new smapi.academic.SAPConfigurationScopeModel().LoadFromResponse(responseData.SAPScope));
            }
            if (responseData.GradeEffectType != null) {
                loaded.GradeEffectType(new smapi.academic.GradeEffectTypeModel().LoadFromResponse(responseData.GradeEffectType));
            }
            if (responseData.RepeatPolicy != null) {
                loaded.RepeatPolicy(new smapi.academic.RepeatPolicyModel().LoadFromResponse(responseData.RepeatPolicy));
            }
            if (responseData.EvaluationPeriodTypes != null && responseData.EvaluationPeriodTypes.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.EvaluationPeriodTypes.length; i++) {
                    items.push(new smapi.academic.AcademicPeriodTypeModel().LoadFromResponse(responseData.EvaluationPeriodTypes[i]));
                }
                loaded.EvaluationPeriodTypes(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.ClassType.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CSSClassName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Occurrence.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.HoldTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.StandingTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicAchievementTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SAPScopeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Frequency.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.GradeEffectTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RepeatPolicyID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EvaluationMonth.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EvaluationDayOfMonth.extend({
            min: {
                params: -32768,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 32767,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.MaxResetCount.extend({
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressStatusFlowModel(options) {
        var defaults = {
            StartingStatusID: null,
            NextStatusID: null,
            EvaluationWorkflowID: null,
            SortOrder: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.StartingStatusID = ko.validatedObservable(settings.StartingStatusID);
        this.NextStatusID = ko.validatedObservable(settings.NextStatusID);
        this.EvaluationWorkflowID = ko.validatedObservable(settings.EvaluationWorkflowID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.StartingStatus = ko.observable();
        this.NextStatus = ko.observable();
        this.EvaluationWorkflow = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.StartingStatusID != undefined) {
                loaded.StartingStatusID(responseData.StartingStatusID);
            }
            if (responseData.NextStatusID != undefined) {
                loaded.NextStatusID(responseData.NextStatusID);
            }
            if (responseData.EvaluationWorkflowID != undefined) {
                loaded.EvaluationWorkflowID(responseData.EvaluationWorkflowID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.StartingStatus != null) {
                loaded.StartingStatus(new smapi.academic.AcademicProgressStatusModel().LoadFromResponse(responseData.StartingStatus));
            }
            if (responseData.NextStatus != null) {
                loaded.NextStatus(new smapi.academic.AcademicProgressStatusModel().LoadFromResponse(responseData.NextStatus));
            }
            if (responseData.EvaluationWorkflow != null) {
                loaded.EvaluationWorkflow(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.EvaluationWorkflow));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressStatusFlow', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.StartingStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NextStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EvaluationWorkflowID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressStatusAppealModel(options) {
        var defaults = {
            AcademicProgressAlertID: 0,
            AppealReasonID: 0,
            SpecialCircumstances: '',
            AppealEvalCommSent: false,
            GrantedStatusID: 0,
            GrantedByID: null,
            AcademicPlanID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicProgressAlertID = ko.validatedObservable(settings.AcademicProgressAlertID);
        this.AppealReasonID = ko.validatedObservable(settings.AppealReasonID);
        this.SpecialCircumstances = ko.validatedObservable(settings.SpecialCircumstances);
        this.AppealEvalCommSent = ko.validatedObservable(settings.AppealEvalCommSent);
        this.GrantedStatusID = ko.validatedObservable(settings.GrantedStatusID);
        this.GrantedByID = ko.validatedObservable(settings.GrantedByID);
        this.AcademicPlanID = ko.validatedObservable(settings.AcademicPlanID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicProgressAlert = ko.observable();
        this.AppealReason = ko.observable();
        this.GrantedStatus = ko.observable();
        this.GrantedBy = ko.observable();
        this.AcademicPlan = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicProgressAlertID != undefined) {
                loaded.AcademicProgressAlertID(responseData.AcademicProgressAlertID);
            }
            if (responseData.AppealReasonID != undefined) {
                loaded.AppealReasonID(responseData.AppealReasonID);
            }
            if (responseData.SpecialCircumstances != undefined) {
                loaded.SpecialCircumstances(responseData.SpecialCircumstances);
            }
            if (responseData.AppealEvalCommSent != undefined) {
                loaded.AppealEvalCommSent(responseData.AppealEvalCommSent);
            }
            if (responseData.GrantedStatusID != undefined) {
                loaded.GrantedStatusID(responseData.GrantedStatusID);
            }
            if (responseData.GrantedByID != undefined) {
                loaded.GrantedByID(responseData.GrantedByID);
            }
            if (responseData.AcademicPlanID != undefined) {
                loaded.AcademicPlanID(responseData.AcademicPlanID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicProgressAlert != null) {
                loaded.AcademicProgressAlert(new smapi.academic.AcademicProgressAlertModel().LoadFromResponse(responseData.AcademicProgressAlert));
            }
            if (responseData.AppealReason != null) {
                loaded.AppealReason(new smapi.academic.AcademicStatusAppealReasonModel().LoadFromResponse(responseData.AppealReason));
            }
            if (responseData.GrantedStatus != null) {
                loaded.GrantedStatus(new smapi.academic.AcademicProgressStatusModel().LoadFromResponse(responseData.GrantedStatus));
            }
            if (responseData.GrantedBy != null) {
                loaded.GrantedBy(new smapi.entities.UserModel().LoadFromResponse(responseData.GrantedBy));
            }
            if (responseData.AcademicPlan != null) {
                loaded.AcademicPlan(new smapi.academic.AcademicPlanModel().LoadFromResponse(responseData.AcademicPlan));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressStatusAppeal', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicProgressAlertID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AppealReasonID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GrantedStatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GrantedByID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicPlanID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressAlertModel(options) {
        var defaults = {
            StudentID: 0,
            AlertStatusID: null,
            AppealID: null,
            AcademicPlanID: null,
            ResolvedSetByID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.StudentID = ko.validatedObservable(settings.StudentID);
        this.AlertStatusID = ko.validatedObservable(settings.AlertStatusID);
        this.AppealID = ko.validatedObservable(settings.AppealID);
        this.AcademicPlanID = ko.validatedObservable(settings.AcademicPlanID);
        this.ResolvedSetByID = ko.validatedObservable(settings.ResolvedSetByID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Student = ko.observable();
        this.AlertStatus = ko.observable();
        this.Appeal = ko.observableArray([]);
        this.AcademicPlan = ko.observable();
        this.ResolvedSetBy = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.StudentID != undefined) {
                loaded.StudentID(responseData.StudentID);
            }
            if (responseData.AlertStatusID != undefined) {
                loaded.AlertStatusID(responseData.AlertStatusID);
            }
            if (responseData.AppealID != undefined) {
                loaded.AppealID(responseData.AppealID);
            }
            if (responseData.AcademicPlanID != undefined) {
                loaded.AcademicPlanID(responseData.AcademicPlanID);
            }
            if (responseData.ResolvedSetByID != undefined) {
                loaded.ResolvedSetByID(responseData.ResolvedSetByID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Student != null) {
                loaded.Student(new smapi.academic.StudentModel().LoadFromResponse(responseData.Student));
            }
            if (responseData.AlertStatus != null) {
                loaded.AlertStatus(new smapi.academic.AcademicProgressStatusModel().LoadFromResponse(responseData.AlertStatus));
            }
            if (responseData.Appeal != null && responseData.Appeal.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Appeal.length; i++) {
                    items.push(new smapi.academic.AcademicProgressStatusAppealModel().LoadFromResponse(responseData.Appeal[i]));
                }
                loaded.Appeal(items);
            }
            if (responseData.AcademicPlan != null) {
                loaded.AcademicPlan(new smapi.academic.AcademicPlanModel().LoadFromResponse(responseData.AcademicPlan));
            }
            if (responseData.ResolvedSetBy != null) {
                loaded.ResolvedSetBy(new smapi.entities.UserModel().LoadFromResponse(responseData.ResolvedSetBy));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressAlert', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.StudentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AlertStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AppealID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicPlanID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ResolvedSetByID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseUnitTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseUnitType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseUnitMeasureModel(options) {
        var defaults = {
            UnitValue: 0,
            EffectiveFromDate: null,
            EffectiveToDate: null,
            CourseUnitTypeID: null,
            CourseMasterID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.UnitValue = ko.validatedObservable(settings.UnitValue);
        this.EffectiveFromDate = ko.validatedObservable(settings.EffectiveFromDate);
        this.EffectiveToDate = ko.validatedObservable(settings.EffectiveToDate);
        this.CourseUnitTypeID = ko.validatedObservable(settings.CourseUnitTypeID);
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseMaster = ko.observable();
        this.UnitType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.UnitValue != undefined) {
                loaded.UnitValue(responseData.UnitValue);
            }
            if (responseData.EffectiveFromDate != undefined) {
                loaded.EffectiveFromDate(responseData.EffectiveFromDate);
            }
            if (responseData.EffectiveToDate != undefined) {
                loaded.EffectiveToDate(responseData.EffectiveToDate);
            }
            if (responseData.CourseUnitTypeID != undefined) {
                loaded.CourseUnitTypeID(responseData.CourseUnitTypeID);
            }
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseMaster != null) {
                loaded.CourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseMaster));
            }
            if (responseData.UnitType != null) {
                loaded.UnitType(new smapi.academic.CourseUnitTypeModel().LoadFromResponse(responseData.UnitType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseUnitMeasure', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.UnitValue.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EffectiveFromDate.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.EffectiveToDate.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.CourseUnitTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseMasterID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LanguageOfInstructionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.LanguageOfInstruction', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function QualificationModeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.QualificationMode', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function EnrollmentGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.EnrollmentGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 100,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ActivityStatusModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ActivityStatus', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function StudentActivityGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.StudentActivityGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ActivityCompetencyModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ActivityCompetency', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ActivityPositionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ActivityPosition', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function SkillModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.Skill', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ActivityCompensationModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ActivityCompensation', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function StudentActivityTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            StudentActivityGroupID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.StudentActivityGroupID = ko.validatedObservable(settings.StudentActivityGroupID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.StudentActivityGroup = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.StudentActivityGroupID != undefined) {
                loaded.StudentActivityGroupID(responseData.StudentActivityGroupID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.StudentActivityGroup != null) {
                loaded.StudentActivityGroup(new smapi.academic.StudentActivityGroupModel().LoadFromResponse(responseData.StudentActivityGroup));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.StudentActivityType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.StudentActivityGroupID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcceptableRecordModel(options) {
        var defaults = {
            RecordGID: null,
            NonCourseRequisiteID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.RecordGID = ko.validatedObservable(settings.RecordGID);
        this.NonCourseRequisiteID = ko.validatedObservable(settings.NonCourseRequisiteID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.NonCourseRequisite = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.RecordGID != undefined) {
                loaded.RecordGID(responseData.RecordGID);
            }
            if (responseData.NonCourseRequisiteID != undefined) {
                loaded.NonCourseRequisiteID(responseData.NonCourseRequisiteID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.NonCourseRequisite != null) {
                loaded.NonCourseRequisite(new smapi.academic.NonCourseRequisiteModel().LoadFromResponse(responseData.NonCourseRequisite));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcceptableRecord', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.RecordGID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        this.NonCourseRequisiteID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function NonCourseRequisiteTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SelectorView: '',
            RuleSetID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SelectorView = ko.validatedObservable(settings.SelectorView);
        this.RuleSetID = ko.validatedObservable(settings.RuleSetID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RuleSet = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SelectorView != undefined) {
                loaded.SelectorView(responseData.SelectorView);
            }
            if (responseData.RuleSetID != undefined) {
                loaded.RuleSetID(responseData.RuleSetID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RuleSet != null) {
                loaded.RuleSet(new smapi.entities.TRSRuleSetModel().LoadFromResponse(responseData.RuleSet));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.NonCourseRequisiteType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.SelectorView.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.RuleSetID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function NonCourseRequisiteModel(options) {
        var defaults = {
            GreaterThanValue: 0,
            LessThanValue: 0,
            EqualToValue: 0,
            NonCourseRequisiteTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.GreaterThanValue = ko.validatedObservable(settings.GreaterThanValue);
        this.LessThanValue = ko.validatedObservable(settings.LessThanValue);
        this.EqualToValue = ko.validatedObservable(settings.EqualToValue);
        this.NonCourseRequisiteTypeID = ko.validatedObservable(settings.NonCourseRequisiteTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.NonCourseRequisiteType = ko.observable();
        this.AcceptableRecords = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.GreaterThanValue != undefined) {
                loaded.GreaterThanValue(responseData.GreaterThanValue);
            }
            if (responseData.LessThanValue != undefined) {
                loaded.LessThanValue(responseData.LessThanValue);
            }
            if (responseData.EqualToValue != undefined) {
                loaded.EqualToValue(responseData.EqualToValue);
            }
            if (responseData.NonCourseRequisiteTypeID != undefined) {
                loaded.NonCourseRequisiteTypeID(responseData.NonCourseRequisiteTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.NonCourseRequisiteType != null) {
                loaded.NonCourseRequisiteType(new smapi.academic.NonCourseRequisiteTypeModel().LoadFromResponse(responseData.NonCourseRequisiteType));
            }
            if (responseData.AcceptableRecords != null && responseData.AcceptableRecords.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.AcceptableRecords.length; i++) {
                    items.push(new smapi.academic.AcceptableRecordModel().LoadFromResponse(responseData.AcceptableRecords[i]));
                }
                loaded.AcceptableRecords(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.NonCourseRequisite', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.GreaterThanValue.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.LessThanValue.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.EqualToValue.extend({
            min: {
                params: -79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 79228162514264337593543950335,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.NonCourseRequisiteTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequisiteTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequisiteType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequisiteQualifierRuleTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequisiteQualifierRuleType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequisiteCourseModel(options) {
        var defaults = {
            CourseMasterID: 0,
            CourseRequisiteID: 0,
            IsRequired: false,
            AllowTransfer: false,
            AllowEquivalence: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.CourseRequisiteID = ko.validatedObservable(settings.CourseRequisiteID);
        this.IsRequired = ko.validatedObservable(settings.IsRequired);
        this.AllowTransfer = ko.validatedObservable(settings.AllowTransfer);
        this.AllowEquivalence = ko.validatedObservable(settings.AllowEquivalence);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseMaster = ko.observable();
        this.CourseRequisite = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.CourseRequisiteID != undefined) {
                loaded.CourseRequisiteID(responseData.CourseRequisiteID);
            }
            if (responseData.IsRequired != undefined) {
                loaded.IsRequired(responseData.IsRequired);
            }
            if (responseData.AllowTransfer != undefined) {
                loaded.AllowTransfer(responseData.AllowTransfer);
            }
            if (responseData.AllowEquivalence != undefined) {
                loaded.AllowEquivalence(responseData.AllowEquivalence);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseMaster != null) {
                loaded.CourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseMaster));
            }
            if (responseData.CourseRequisite != null) {
                loaded.CourseRequisite(new smapi.academic.CourseRequisiteModel().LoadFromResponse(responseData.CourseRequisite));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequisiteCourse', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseMasterID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseRequisiteID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequisiteQualifierRuleModel(options) {
        var defaults = {
            CourseRequisiteQualifierRuleTypeID: 0,
            CourseRequisiteQualifierBlockID: 0,
            UnitOfMeasureID: null,
            AcademicDepartmentID: null,
            AcademicSubjectAreaID: null,
            IntValue1: 0,
            IntValue2: 0,
            DoubleValue1: 0,
            DoubleValue2: 0,
            SortOrder: 0,
            ComparisonOperator: null,
            CourseMasterID: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseRequisiteQualifierRuleTypeID = ko.validatedObservable(settings.CourseRequisiteQualifierRuleTypeID);
        this.CourseRequisiteQualifierBlockID = ko.validatedObservable(settings.CourseRequisiteQualifierBlockID);
        this.UnitOfMeasureID = ko.validatedObservable(settings.UnitOfMeasureID);
        this.AcademicDepartmentID = ko.validatedObservable(settings.AcademicDepartmentID);
        this.AcademicSubjectAreaID = ko.validatedObservable(settings.AcademicSubjectAreaID);
        this.IntValue1 = ko.validatedObservable(settings.IntValue1);
        this.IntValue2 = ko.validatedObservable(settings.IntValue2);
        this.DoubleValue1 = ko.validatedObservable(settings.DoubleValue1);
        this.DoubleValue2 = ko.validatedObservable(settings.DoubleValue2);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ComparisonOperator = ko.validatedObservable(settings.ComparisonOperator);
        this.CourseMasterID = ko.validatedObservable(settings.CourseMasterID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RuleType = ko.observable();
        this.QualifierBlock = ko.observable();
        this.UnitOfMeasure = ko.observable();
        this.AcademicDepartment = ko.observable();
        this.AcademicSubjectArea = ko.observable();
        this.CourseMaster = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseRequisiteQualifierRuleTypeID != undefined) {
                loaded.CourseRequisiteQualifierRuleTypeID(responseData.CourseRequisiteQualifierRuleTypeID);
            }
            if (responseData.CourseRequisiteQualifierBlockID != undefined) {
                loaded.CourseRequisiteQualifierBlockID(responseData.CourseRequisiteQualifierBlockID);
            }
            if (responseData.UnitOfMeasureID != undefined) {
                loaded.UnitOfMeasureID(responseData.UnitOfMeasureID);
            }
            if (responseData.AcademicDepartmentID != undefined) {
                loaded.AcademicDepartmentID(responseData.AcademicDepartmentID);
            }
            if (responseData.AcademicSubjectAreaID != undefined) {
                loaded.AcademicSubjectAreaID(responseData.AcademicSubjectAreaID);
            }
            if (responseData.IntValue1 != undefined) {
                loaded.IntValue1(responseData.IntValue1);
            }
            if (responseData.IntValue2 != undefined) {
                loaded.IntValue2(responseData.IntValue2);
            }
            if (responseData.DoubleValue1 != undefined) {
                loaded.DoubleValue1(responseData.DoubleValue1);
            }
            if (responseData.DoubleValue2 != undefined) {
                loaded.DoubleValue2(responseData.DoubleValue2);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ComparisonOperator != undefined) {
                loaded.ComparisonOperator(responseData.ComparisonOperator);
            }
            if (responseData.CourseMasterID != undefined) {
                loaded.CourseMasterID(responseData.CourseMasterID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RuleType != null) {
                loaded.RuleType(new smapi.academic.CourseRequisiteQualifierRuleTypeModel().LoadFromResponse(responseData.RuleType));
            }
            if (responseData.QualifierBlock != null) {
                loaded.QualifierBlock(new smapi.academic.CourseRequisiteQualifierBlockModel().LoadFromResponse(responseData.QualifierBlock));
            }
            if (responseData.UnitOfMeasure != null) {
                loaded.UnitOfMeasure(new smapi.academic.CourseUnitModel().LoadFromResponse(responseData.UnitOfMeasure));
            }
            if (responseData.AcademicDepartment != null) {
                loaded.AcademicDepartment(new smapi.academic.AcademicDepartmentModel().LoadFromResponse(responseData.AcademicDepartment));
            }
            if (responseData.AcademicSubjectArea != null) {
                loaded.AcademicSubjectArea(new smapi.academic.AcademicSubjectAreaModel().LoadFromResponse(responseData.AcademicSubjectArea));
            }
            if (responseData.CourseMaster != null) {
                loaded.CourseMaster(new smapi.academic.CourseMasterModel().LoadFromResponse(responseData.CourseMaster));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequisiteQualifierRule', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseRequisiteQualifierRuleTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.CourseRequisiteQualifierBlockID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UnitOfMeasureID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicDepartmentID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicSubjectAreaID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IntValue1.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IntValue2.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DoubleValue1.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DoubleValue2.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.CourseMasterID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequisiteQualifierBlockModel(options) {
        var defaults = {
            CourseRequisiteID: 0,
            SortOrder: 0,
            Operator: null,
            OuterOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseRequisiteID = ko.validatedObservable(settings.CourseRequisiteID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.Operator = ko.validatedObservable(settings.Operator);
        this.OuterOperator = ko.validatedObservable(settings.OuterOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.CourseRequisite = ko.observable();
        this.Rules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseRequisiteID != undefined) {
                loaded.CourseRequisiteID(responseData.CourseRequisiteID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.Operator != undefined) {
                loaded.Operator(responseData.Operator);
            }
            if (responseData.OuterOperator != undefined) {
                loaded.OuterOperator(responseData.OuterOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.CourseRequisite != null) {
                loaded.CourseRequisite(new smapi.academic.CourseRequisiteModel().LoadFromResponse(responseData.CourseRequisite));
            }
            if (responseData.Rules != null && responseData.Rules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Rules.length; i++) {
                    items.push(new smapi.academic.CourseRequisiteQualifierRuleModel().LoadFromResponse(responseData.Rules[i]));
                }
                loaded.Rules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequisiteQualifierBlock', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseRequisiteID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Operator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.OuterOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function CourseRequisiteModel(options) {
        var defaults = {
            CourseRequisiteTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.CourseRequisiteTypeID = ko.validatedObservable(settings.CourseRequisiteTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.Type = ko.observable();
        this.Courses = ko.observableArray([]);
        this.QualfierBlocks = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.CourseRequisiteTypeID != undefined) {
                loaded.CourseRequisiteTypeID(responseData.CourseRequisiteTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Type != null) {
                loaded.Type(new smapi.academic.CourseRequisiteTypeModel().LoadFromResponse(responseData.Type));
            }
            if (responseData.Courses != null && responseData.Courses.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Courses.length; i++) {
                    items.push(new smapi.academic.CourseRequisiteCourseModel().LoadFromResponse(responseData.Courses[i]));
                }
                loaded.Courses(items);
            }
            if (responseData.QualfierBlocks != null && responseData.QualfierBlocks.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.QualfierBlocks.length; i++) {
                    items.push(new smapi.academic.CourseRequisiteQualifierBlockModel().LoadFromResponse(responseData.QualfierBlocks[i]));
                }
                loaded.QualfierBlocks(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.CourseRequisite', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.CourseRequisiteTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ResitOptionModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ResitOption', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ResitPolicyModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ResitPolicy', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ComponentActivityModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ComponentActivity', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function ComponentAssessmentTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.ComponentAssessmentType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AssessmentCategoryTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            SystemProtected: false,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.SystemProtected = ko.validatedObservable(settings.SystemProtected);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.SystemProtected != undefined) {
                loaded.SystemProtected(responseData.SystemProtected);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AssessmentCategoryType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LearningOutcomeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            SortOrder: 0,
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.LearningOutcome', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -2147483648,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 2147483647,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressStatusRuleTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressStatusRuleType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 512,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '512')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressStatusRuleModel(options) {
        var defaults = {
            AcademicProgressStatusRuleTypeID: 0,
            AcademicProgressStatusBlockID: 0,
            IntValue1: 0,
            IntValue2: 0,
            DoubleValue1: 0,
            DoubleValue2: 0,
            SortOrder: 0,
            ComparisonOperator: null,
            EducationalGoalID: 0,
            AcademicLevelID: 0,
            AcademicProgramID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicProgressStatusRuleTypeID = ko.validatedObservable(settings.AcademicProgressStatusRuleTypeID);
        this.AcademicProgressStatusBlockID = ko.validatedObservable(settings.AcademicProgressStatusBlockID);
        this.IntValue1 = ko.validatedObservable(settings.IntValue1);
        this.IntValue2 = ko.validatedObservable(settings.IntValue2);
        this.DoubleValue1 = ko.validatedObservable(settings.DoubleValue1);
        this.DoubleValue2 = ko.validatedObservable(settings.DoubleValue2);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.ComparisonOperator = ko.validatedObservable(settings.ComparisonOperator);
        this.EducationalGoalID = ko.validatedObservable(settings.EducationalGoalID);
        this.AcademicLevelID = ko.validatedObservable(settings.AcademicLevelID);
        this.AcademicProgramID = ko.validatedObservable(settings.AcademicProgramID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.RuleType = ko.observable();
        this.AcademicProgressStatusBlock = ko.observable();
        this.EducationalGoal = ko.observable();
        this.AcademicLevel = ko.observable();
        this.AcademicProgram = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicProgressStatusRuleTypeID != undefined) {
                loaded.AcademicProgressStatusRuleTypeID(responseData.AcademicProgressStatusRuleTypeID);
            }
            if (responseData.AcademicProgressStatusBlockID != undefined) {
                loaded.AcademicProgressStatusBlockID(responseData.AcademicProgressStatusBlockID);
            }
            if (responseData.IntValue1 != undefined) {
                loaded.IntValue1(responseData.IntValue1);
            }
            if (responseData.IntValue2 != undefined) {
                loaded.IntValue2(responseData.IntValue2);
            }
            if (responseData.DoubleValue1 != undefined) {
                loaded.DoubleValue1(responseData.DoubleValue1);
            }
            if (responseData.DoubleValue2 != undefined) {
                loaded.DoubleValue2(responseData.DoubleValue2);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.ComparisonOperator != undefined) {
                loaded.ComparisonOperator(responseData.ComparisonOperator);
            }
            if (responseData.EducationalGoalID != undefined) {
                loaded.EducationalGoalID(responseData.EducationalGoalID);
            }
            if (responseData.AcademicLevelID != undefined) {
                loaded.AcademicLevelID(responseData.AcademicLevelID);
            }
            if (responseData.AcademicProgramID != undefined) {
                loaded.AcademicProgramID(responseData.AcademicProgramID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.RuleType != null) {
                loaded.RuleType(new smapi.academic.AcademicProgressStatusRuleTypeModel().LoadFromResponse(responseData.RuleType));
            }
            if (responseData.AcademicProgressStatusBlock != null) {
                loaded.AcademicProgressStatusBlock(new smapi.academic.AcademicProgressStatusBlockModel().LoadFromResponse(responseData.AcademicProgressStatusBlock));
            }
            if (responseData.EducationalGoal != null) {
                loaded.EducationalGoal(new smapi.academic.EducationalGoalModel().LoadFromResponse(responseData.EducationalGoal));
            }
            if (responseData.AcademicLevel != null) {
                loaded.AcademicLevel(new smapi.academic.AcademicLevelModel().LoadFromResponse(responseData.AcademicLevel));
            }
            if (responseData.AcademicProgram != null) {
                loaded.AcademicProgram(new smapi.academic.AcademicProgramModel().LoadFromResponse(responseData.AcademicProgram));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressStatusRule', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicProgressStatusRuleTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicProgressStatusBlockID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IntValue1.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.IntValue2.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DoubleValue1.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.DoubleValue2.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 179769313486232000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ComparisonOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.EducationalGoalID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicLevelID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AcademicProgramID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function AcademicProgressStatusBlockModel(options) {
        var defaults = {
            AcademicProgressStatusID: 0,
            SortOrder: 0,
            Operator: null,
            OuterOperator: null,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.AcademicProgressStatusID = ko.validatedObservable(settings.AcademicProgressStatusID);
        this.SortOrder = ko.validatedObservable(settings.SortOrder);
        this.Operator = ko.validatedObservable(settings.Operator);
        this.OuterOperator = ko.validatedObservable(settings.OuterOperator);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.AcademicProgressStatus = ko.observable();
        this.Rules = ko.observableArray([]);
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.AcademicProgressStatusID != undefined) {
                loaded.AcademicProgressStatusID(responseData.AcademicProgressStatusID);
            }
            if (responseData.SortOrder != undefined) {
                loaded.SortOrder(responseData.SortOrder);
            }
            if (responseData.Operator != undefined) {
                loaded.Operator(responseData.Operator);
            }
            if (responseData.OuterOperator != undefined) {
                loaded.OuterOperator(responseData.OuterOperator);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.AcademicProgressStatus != null) {
                loaded.AcademicProgressStatus(new smapi.academic.AcademicProgressStatusModel().LoadFromResponse(responseData.AcademicProgressStatus));
            }
            if (responseData.Rules != null && responseData.Rules.length > 0) {
                var items = new Array();
                for (var i=0; i < responseData.Rules.length; i++) {
                    items.push(new smapi.academic.AcademicProgressStatusRuleModel().LoadFromResponse(responseData.Rules[i]));
                }
                loaded.Rules(items);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.AcademicProgressStatusBlock', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.AcademicProgressStatusID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Operator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.OuterOperator.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function StudentGroupTypeModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.StudentGroupType', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function StudentGroupModel(options) {
        var defaults = {
            Name: '',
            Description: '',
            BusinessMeaningName: '',
            StudentGroupTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };
        
        var settings = jQuery.extend({}, defaults, options);
        
        // Self-Identification
        var self = this;
        
        // ATO Properties
        this.APILink = ko.observable(settings.APILink);
        
        // Properties as Observables
        this.Name = ko.validatedObservable(settings.Name);
        this.Description = ko.validatedObservable(settings.Description);
        this.BusinessMeaningName = ko.validatedObservable(settings.BusinessMeaningName);
        this.StudentGroupTypeID = ko.validatedObservable(settings.StudentGroupTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);
        
        // Relationships as Observables and ObservableArrays
        this.StudentGroupType = ko.observable();
        
        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;
            
            if (responseData.APILink != undefined)
            {
                loaded.APILink(responseData.APILink);
            }
            
            if (responseData.Name != undefined) {
                loaded.Name(responseData.Name);
            }
            if (responseData.Description != undefined) {
                loaded.Description(responseData.Description);
            }
            if (responseData.BusinessMeaningName != undefined) {
                loaded.BusinessMeaningName(responseData.BusinessMeaningName);
            }
            if (responseData.StudentGroupTypeID != undefined) {
                loaded.StudentGroupTypeID(responseData.StudentGroupTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.StudentGroupType != null) {
                loaded.StudentGroupType(new smapi.academic.StudentGroupTypeModel().LoadFromResponse(responseData.StudentGroupType));
            }
            return loaded;
        };
        
        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Academic.Entity.StudentGroup', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                
                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                } 
            });
        }
        
        this.Name.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.Description.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '255')
            }
        });
        this.BusinessMeaningName.extend({
            maxLength: {
                params: 50,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '50')
            }
        });
        this.StudentGroupTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }, 
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }, 
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });
        
        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        
        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function() {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        
        return self;
    }
    
    
    function LoadTemplates(basePath, targetDiv) {
        var uri = basePath + '/SMAPI.academic.combined-1.0.0.html';
        jQuery.ajax({
            url: uri,
            type: 'GET',
            async: false,
            success: function (template) {
                jQuery("#" + targetDiv).append(template);
            }
        });
    }
    
    
    $.extend(true, smapi.academic, {
        RepeatPolicyModel: RepeatPolicyModel,
        DivisionModel: DivisionModel,
        AcademicDeliveryMethodModel: AcademicDeliveryMethodModel,
        AcademicLevelModel: AcademicLevelModel,
        StudentModel: StudentModel,
        EnrollmentLevelModel: EnrollmentLevelModel,
        EmployeeModel: EmployeeModel,
        MatriculationStatusModel: MatriculationStatusModel,
        AthleticEligibilityCenterModel: AthleticEligibilityCenterModel,
        FERPAAlertsModel: FERPAAlertsModel,
        EducationalGoalModel: EducationalGoalModel,
        ExternalEducationalGoalModel: ExternalEducationalGoalModel,
        CollegeCodeModel: CollegeCodeModel,
        CollegeModel: CollegeModel,
        AcademicPeriodOverlapModel: AcademicPeriodOverlapModel,
        AcademicPeriodTypeModel: AcademicPeriodTypeModel,
        AcademicPeriodModel: AcademicPeriodModel,
        PeriodDurationTypeModel: PeriodDurationTypeModel,
        PeriodDurationTypeThresholdModel: PeriodDurationTypeThresholdModel,
        ThresholdTypeModel: ThresholdTypeModel,
        ProgramMasterModel: ProgramMasterModel,
        ConcentrationTypeModel: ConcentrationTypeModel,
        HonorModel: HonorModel,
        ConcentrationMasterModel: ConcentrationMasterModel,
        PersonAcademicGoalConcentrationModel: PersonAcademicGoalConcentrationModel,
        PersonAcademicGoalHonorModel: PersonAcademicGoalHonorModel,
        PersonAcademicGoalModel: PersonAcademicGoalModel,
        CourseTypeModel: CourseTypeModel,
        CourseNeedMasterModel: CourseNeedMasterModel,
        CourseNeedModel: CourseNeedModel,
        LocationPropertyModel: LocationPropertyModel,
        CourseGroupModel: CourseGroupModel,
        GradeCatalogModel: GradeCatalogModel,
        GradeEffectModel: GradeEffectModel,
        GradeEffectTypeModel: GradeEffectTypeModel,
        GradeMasterGradeEffectModel: GradeMasterGradeEffectModel,
        GradeMasterModel: GradeMasterModel,
        CourseCatalogModel: CourseCatalogModel,
        CourseEnrollmentModeModel: CourseEnrollmentModeModel,
        EnrollmentModeMinGradeModel: EnrollmentModeMinGradeModel,
        CourseMasterMinGradeOverrideModel: CourseMasterMinGradeOverrideModel,
        CourseMasterModel: CourseMasterModel,
        GoalStandingMasterModel: GoalStandingMasterModel,
        EnrollmentStatusMasterModel: EnrollmentStatusMasterModel,
        AcademicPeriodMilestoneGroupModel: AcademicPeriodMilestoneGroupModel,
        AcademicPeriodMilestoneTypeModel: AcademicPeriodMilestoneTypeModel,
        AcademicPeriodMilestoneCriteriaModel: AcademicPeriodMilestoneCriteriaModel,
        ProgramTypeModel: ProgramTypeModel,
        AcademicPeriodMilestoneMasterModel: AcademicPeriodMilestoneMasterModel,
        CourseRequirementModel: CourseRequirementModel,
        AcademicRequirementModel: AcademicRequirementModel,
        CourseRequirementMasterModel: CourseRequirementMasterModel,
        CourseEquivalenceModel: CourseEquivalenceModel,
        ProgramCategoryModel: ProgramCategoryModel,
        ProgramConcentrationModel: ProgramConcentrationModel,
        AcademicManagerTypeModel: AcademicManagerTypeModel,
        AcademicProgramManagerModel: AcademicProgramManagerModel,
        AcademicProgramModel: AcademicProgramModel,
        ExternalAcademicProgramModel: ExternalAcademicProgramModel,
        CatalogCategoryModel: CatalogCategoryModel,
        GradeTypeModel: GradeTypeModel,
        GradeFormatModel: GradeFormatModel,
        RequirementCategoryModel: RequirementCategoryModel,
        GradeProcessModel: GradeProcessModel,
        EnrollmentLoadModel: EnrollmentLoadModel,
        GoalTypeModel: GoalTypeModel,
        PersonGoalProgramModel: PersonGoalProgramModel,
        ReasonModel: ReasonModel,
        PersonMetRequirementModel: PersonMetRequirementModel,
        MetRequirementCourseModel: MetRequirementCourseModel,
        ProgramStatusModel: ProgramStatusModel,
        AcademicDepartmentModel: AcademicDepartmentModel,
        AcademicSubjectAreaModel: AcademicSubjectAreaModel,
        CourseGroupQualifierRuleTypeModel: CourseGroupQualifierRuleTypeModel,
        CourseUnitModel: CourseUnitModel,
        CourseGroupQueryFilterTypeModel: CourseGroupQueryFilterTypeModel,
        PeriodOfCompletionUnitModel: PeriodOfCompletionUnitModel,
        CourseGroupCourseModel: CourseGroupCourseModel,
        DegreeCourseGroupModel: DegreeCourseGroupModel,
        CourseGroupQualifierRuleValueModel: CourseGroupQualifierRuleValueModel,
        CourseGroupQualifierRuleModel: CourseGroupQualifierRuleModel,
        CourseGroupQualifierBlockModel: CourseGroupQualifierBlockModel,
        CourseGroupQueryFilterValueModel: CourseGroupQueryFilterValueModel,
        CourseGroupQueryFilterModel: CourseGroupQueryFilterModel,
        CourseGroupQueryBlockModel: CourseGroupQueryBlockModel,
        CourseGroupQueryModel: CourseGroupQueryModel,
        DegreeRequirementModel: DegreeRequirementModel,
        DegreeRequirementQualifierRuleModel: DegreeRequirementQualifierRuleModel,
        DegreeRequirementQualifierBlockModel: DegreeRequirementQualifierBlockModel,
        DegreeAuditHistoryDetailModel: DegreeAuditHistoryDetailModel,
        DegreeAuditHistoryModel: DegreeAuditHistoryModel,
        DegreeAuditModel: DegreeAuditModel,
        DegreeAuditMilestoneTypeModel: DegreeAuditMilestoneTypeModel,
        AcademicMilestoneTypeModel: AcademicMilestoneTypeModel,
        DegreeRequirementMilestoneTypeModel: DegreeRequirementMilestoneTypeModel,
        DegreeRequirementMilestoneModel: DegreeRequirementMilestoneModel,
        RequirementMilestoneRuleModel: RequirementMilestoneRuleModel,
        RequirementMilestoneRuleBlockModel: RequirementMilestoneRuleBlockModel,
        AcademicReportingCodeTypeModel: AcademicReportingCodeTypeModel,
        AcademicReportingCodeModel: AcademicReportingCodeModel,
        ExternalAcademicReportingCodeModel: ExternalAcademicReportingCodeModel,
        FundingSourceModel: FundingSourceModel,
        CourseMasterFundingSourceModel: CourseMasterFundingSourceModel,
        SAPConfigurationScopeModel: SAPConfigurationScopeModel,
        AcademicPlanStepTypeModel: AcademicPlanStepTypeModel,
        AcademicPlanStepModel: AcademicPlanStepModel,
        AcademicPlanModel: AcademicPlanModel,
        AcademicStatusAppealReasonModel: AcademicStatusAppealReasonModel,
        AcademicProgressStandingTypeModel: AcademicProgressStandingTypeModel,
        AcademicAwardTypeModel: AcademicAwardTypeModel,
        AcademicProgressStatusModel: AcademicProgressStatusModel,
        AcademicProgressStatusFlowModel: AcademicProgressStatusFlowModel,
        AcademicProgressStatusAppealModel: AcademicProgressStatusAppealModel,
        AcademicProgressAlertModel: AcademicProgressAlertModel,
        CourseUnitTypeModel: CourseUnitTypeModel,
        CourseUnitMeasureModel: CourseUnitMeasureModel,
        LanguageOfInstructionModel: LanguageOfInstructionModel,
        QualificationModeModel: QualificationModeModel,
        EnrollmentGroupModel: EnrollmentGroupModel,
        ActivityStatusModel: ActivityStatusModel,
        StudentActivityGroupModel: StudentActivityGroupModel,
        ActivityCompetencyModel: ActivityCompetencyModel,
        ActivityPositionModel: ActivityPositionModel,
        SkillModel: SkillModel,
        ActivityCompensationModel: ActivityCompensationModel,
        StudentActivityTypeModel: StudentActivityTypeModel,
        AcceptableRecordModel: AcceptableRecordModel,
        NonCourseRequisiteTypeModel: NonCourseRequisiteTypeModel,
        NonCourseRequisiteModel: NonCourseRequisiteModel,
        CourseRequisiteTypeModel: CourseRequisiteTypeModel,
        CourseRequisiteQualifierRuleTypeModel: CourseRequisiteQualifierRuleTypeModel,
        CourseRequisiteCourseModel: CourseRequisiteCourseModel,
        CourseRequisiteQualifierRuleModel: CourseRequisiteQualifierRuleModel,
        CourseRequisiteQualifierBlockModel: CourseRequisiteQualifierBlockModel,
        CourseRequisiteModel: CourseRequisiteModel,
        ResitOptionModel: ResitOptionModel,
        ResitPolicyModel: ResitPolicyModel,
        ComponentActivityModel: ComponentActivityModel,
        ComponentAssessmentTypeModel: ComponentAssessmentTypeModel,
        AssessmentCategoryTypeModel: AssessmentCategoryTypeModel,
        LearningOutcomeModel: LearningOutcomeModel,
        AcademicProgressStatusRuleTypeModel: AcademicProgressStatusRuleTypeModel,
        AcademicProgressStatusRuleModel: AcademicProgressStatusRuleModel,
        AcademicProgressStatusBlockModel: AcademicProgressStatusBlockModel,
        StudentGroupTypeModel: StudentGroupTypeModel,
        StudentGroupModel: StudentGroupModel,
        LoadTemplates: LoadTemplates
    });
})(jQuery);
